import * as tslib_1 from "tslib";
import { Base } from "../../components/base-component";
import "./calculators-personalloans-amortisation.component.scss";
import * as $ from "jquery";
var Month;
(function (Month) {
    Month[Month["JANUARY"] = 0] = "JANUARY";
    Month[Month["FEBRUARY"] = 1] = "FEBRUARY";
    Month[Month["MARCH"] = 2] = "MARCH";
    Month[Month["APRIL"] = 3] = "APRIL";
    Month[Month["MAY"] = 4] = "MAY";
    Month[Month["JUNE"] = 5] = "JUNE";
    Month[Month["JULY"] = 6] = "JULY";
    Month[Month["AUGUST"] = 7] = "AUGUST";
    Month[Month["SEPTEMBER"] = 8] = "SEPTEMBER";
    Month[Month["OCTOBER"] = 9] = "OCTOBER";
    Month[Month["NOVEMBER"] = 10] = "NOVEMBER";
    Month[Month["DECEMBER"] = 11] = "DECEMBER";
})(Month || (Month = {}));
var AmortisationItem = /** @class */ (function () {
    function AmortisationItem() {
        this.payment = 0.0;
        this.extraPayment = 0.0;
        this.missedPaymentAndRevolves = 0.0;
        this.monthlyServiceFee = 0.0;
        this.insuranceCost = 0.0;
        this.interest = 0.0;
        this.balance = 0.0;
        this.interestRate = 0.0;
    }
    return AmortisationItem;
}());
var CalculatorsPersonalloansAmortisation = /** @class */ (function (_super) {
    tslib_1.__extends(CalculatorsPersonalloansAmortisation, _super);
    function CalculatorsPersonalloansAmortisation(element) {
        var _this = _super.call(this, element) || this;
        _this.formValid = true;
        _this.numberOfAdditionalPayments = 0;
        _this.numberOfMissedPayments = 0;
        _this.numberOfRevolves = 0;
        _this.monthNames = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
        ];
        return _this;
    }
    CalculatorsPersonalloansAmortisation.prototype.init = function () {
        this.calculatorForm = this.element.querySelector("form");
        this.calculatorSubmit = this.calculatorForm.querySelector(".js-wpbbsa-calculator-plua-calculate");
        this.calculatorReset = this.calculatorForm.querySelector(".js-wpbbsa-calculator-plua-reset");
        this.loanTypeSelect = this.calculatorForm.querySelector("select[name=loan-type]");
        this.loanType = "TERM LOAN";
        this.dataHtmlCollection = Array.from(this.element.getElementsByClassName("form__group wpbbsa-calculator-form__group"));
        this.dataHtmlCollection.forEach(function (item, index) {
            if (item.innerHTML.indexOf("form-item__insurance--personal__policy-number-type-container-first") != -1) {
                item.classList.remove("hidden");
            }
            if (item.innerHTML.indexOf("form-item__insurance--personal__policy-number-type-container-second") != -1) {
                item.classList.add("hidden");
            }
        });
        this.numberOfAdditionalPayments = 0;
        this.numberOfMissedPayments = 0;
        this.numberOfRevolves = 0;
        this.loanTypeFormTitle = this.calculatorForm.querySelector("label[for=loan-amount]");
        this.loanTypeTitle = this.element.querySelector(".wpbbsa-calculator-item__box-inner--top__loan-title p");
        this.loanTypeFormStartDateTitle = this.calculatorForm.querySelector("label[for=date-of-loan]");
        this.loanTypeStartDateTitle = this.element.querySelector(".js-wpbbsa-calculator-loan-date--title");
        this.madeAdditionalPayments = this.calculatorForm.querySelector("input[name=made-additional-payments]");
        this.additionalPaymentItems = this.calculatorForm.querySelector("div[name=additional-payment-items]");
        this.addRemoveAdditionalPayments = this.calculatorForm.querySelector(".add-remove-additional-payments");
        this.addAdditionalPaymentDiv = this.calculatorForm.querySelector(".add-additional-payment");
        this.addAdditionalPaymentBtn = this.calculatorForm.querySelector("button[name=add-additional-payment-btn]");
        this.removeAdditionalPaymentDiv = this.calculatorForm.querySelector(".remove-additional-payment");
        this.removeAdditionalPaymentBtn = this.calculatorForm.querySelector("button[name=remove-additional-payment-btn]");
        this.haveMissedPayments = this.calculatorForm.querySelector("input[name=missed-payments]");
        this.missedPaymentItems = this.calculatorForm.querySelector("div[name=missed-payment-items]");
        this.addRemoveMissedPayments = this.calculatorForm.querySelector(".add-remove-missed-payments");
        this.addMissedPaymentDiv = this.calculatorForm.querySelector(".add-missed-payment");
        this.addMissedPaymentBtn = this.calculatorForm.querySelector("button[name=add-missed-payment-btn]");
        this.removeMissedPaymentDiv = this.calculatorForm.querySelector(".remove-missed-payment");
        this.removeMissedPaymentBtn = this.calculatorForm.querySelector("button[name=remove-missed-payment-btn]");
        this.revolved = this.calculatorForm.querySelector("input[name=revolved]");
        this.revolvedItems = this.calculatorForm.querySelector("div[name=revolved-items]");
        this.addRemoveRevolves = this.calculatorForm.querySelector(".add-remove-revolves");
        this.addRevolvedDiv =
            this.calculatorForm.querySelector(".add-revolved");
        this.addRevolvedBtn = this.calculatorForm.querySelector("button[name=add-revolved-btn]");
        this.removeRevolvedDiv =
            this.calculatorForm.querySelector(".remove-revolved");
        this.removeRevolvedBtn = this.calculatorForm.querySelector("button[name=remove-revolved-btn]");
        this.amortisationTableLabel = document.querySelector("label[name=amortisation-table]");
        if (this.loanTypeSelect) {
            this.updateFormLoanType(this.loanType);
        }
    };
    CalculatorsPersonalloansAmortisation.prototype.bindEvents = function () {
        var _this = this;
        this.calculatorSubmit.addEventListener("click", function (event) {
            _this.inputs = Array.from(_this.calculatorForm.querySelectorAll("input, select"));
            _this.amortisationTableLabel.innerHTML =
                "No information to display.";
            var btnViewPayments = Array.from(_this.element.querySelectorAll(".js-wpbbsa-calculator-view-payments"));
            if (_this.inputs) {
                _this.formValid =
                    _this.validationService.validateWpbbsaCalculatorAllFields(_this.inputs, _this.calculatorSubmit);
            }
            if (_this.formValid) {
                _this.doCalcs(_this.calculatorForm);
                // Analytics - Trigger form Complete when the user calculates the results
                _this.analyticsService.dtmFormComplete("complete", "");
                if ($(window).width() > 768) {
                    $("html,body").animate({
                        scrollTop: $(_this.element)
                            .closest(".wpbbsa-calculators")
                            .offset().top - 80,
                    }, "slow");
                    btnViewPayments.forEach(function (element) {
                        element.classList.remove("button--white");
                        element.classList.remove("button--border-blue");
                        element.classList.add("gradient-orange");
                    });
                }
                else if ($(window).width() < 768) {
                    $("html,body").animate({
                        scrollTop: $("div.wpbbsa-calculator-item__box").offset()
                            .top - 80,
                    }, "slow");
                    setTimeout(function () {
                        btnViewPayments.forEach(function (element) {
                            element.classList.remove("button--white");
                            element.classList.remove("button--border-blue");
                            element.classList.add("gradient-orange");
                        });
                    }, 800);
                }
            }
            else {
                if ($(window).width() > 768) {
                    $("html,body").animate({
                        scrollTop: $(_this.element)
                            .closest(".wpbbsa-calculators")
                            .offset().top - 80,
                    }, "slow");
                }
                else if ($(window).width() < 768) {
                    $("html,body").animate({
                        scrollTop: $(_this.element)
                            .closest(".wpbbsa-calculators")
                            .offset().top - 80,
                    }, "slow");
                }
                btnViewPayments.forEach(function (element) {
                    element.classList.remove("gradient-orange");
                    element.classList.add("button--white");
                    element.classList.add("button--border-blue");
                });
            }
        });
        this.calculatorReset.addEventListener("click", function (event) {
            var btnViewPayments = Array.from(document.querySelectorAll(".js-wpbbsa-calculator-view-payments"));
            btnViewPayments.forEach(function (element) {
                element.classList.remove("gradient-orange");
                element.classList.add("button--white");
                element.classList.add("button--border-blue");
            });
            var lblCalculationError = Array.from(document.querySelectorAll("label[name=plua-calculate-calculateError]"));
            lblCalculationError.forEach(function (element) {
                element.innerHTML = "";
            });
            if ($(window).width() > 768) {
                $("html,body").animate({
                    scrollTop: $(_this.element)
                        .closest(".wpbbsa-calculators")
                        .offset().top - 80,
                }, "slow");
            }
            else if ($(window).width() < 768) {
                $("html,body").animate({
                    scrollTop: $(_this.element)
                        .closest(".wpbbsa-calculators")
                        .offset().top - 80,
                }, "slow");
            }
            _this.resetValues();
        });
        if (this.loanTypeSelect) {
            this.loanTypeSelect.addEventListener("change", function (event) {
                if (_this.loanTypeSelect.value === "TERM LOAN") {
                    _this.dataHtmlCollection.forEach(function (item, index) {
                        if (item.innerHTML.indexOf("form-item__insurance--personal__policy-number-type-container-first") != -1) {
                            item.classList.remove("hidden");
                        }
                        if (item.innerHTML.indexOf("form-item__insurance--personal__policy-number-type-container-second") != -1) {
                            item.classList.add("hidden");
                        }
                    });
                }
                else {
                    _this.dataHtmlCollection.forEach(function (item, index) {
                        if (item.innerHTML.indexOf("form-item__insurance--personal__policy-number-type-container-first") != -1) {
                            item.classList.add("hidden");
                        }
                        if (item.innerHTML.indexOf("form-item__insurance--personal__policy-number-type-container-second") != -1) {
                            item.classList.remove("hidden");
                        }
                    });
                }
                _this.updateFormLoanType(_this.loanTypeSelect.value);
            });
        }
        if (this.madeAdditionalPayments) {
            this.madeAdditionalPayments.addEventListener("change", function (event) {
                _this.updateMadeAnAdditionalPayment(_this.madeAdditionalPayments.checked);
            });
        }
        if (this.addAdditionalPaymentBtn) {
            this.addAdditionalPaymentBtn.addEventListener("click", function (event) {
                _this.addAdditionalPayment();
            });
        }
        if (this.removeAdditionalPaymentBtn) {
            this.removeAdditionalPaymentBtn.addEventListener("click", function (event) {
                _this.removeAdditionalPayment();
            });
        }
        if (this.haveMissedPayments) {
            this.haveMissedPayments.addEventListener("change", function (event) {
                _this.updateHaveMissedPayment(_this.haveMissedPayments.checked);
            });
        }
        if (this.addMissedPaymentBtn) {
            this.addMissedPaymentBtn.addEventListener("click", function (event) {
                _this.addMissedPayment();
            });
        }
        if (this.removeMissedPaymentBtn) {
            this.removeMissedPaymentBtn.addEventListener("click", function (event) {
                _this.removeMissedPayment();
            });
        }
        if (this.revolved) {
            this.revolved.addEventListener("change", function (event) {
                _this.updateRevolved(_this.revolved.checked);
            });
        }
        if (this.addRevolvedBtn) {
            this.addRevolvedBtn.addEventListener("click", function (event) {
                _this.addRevolved();
            });
        }
        if (this.removeRevolvedBtn) {
            this.removeRevolvedBtn.addEventListener("click", function (event) {
                _this.removeRevolved();
            });
        }
    };
    CalculatorsPersonalloansAmortisation.prototype.updateFormLoanType = function (loanType) {
        if (loanType === "TERM LOAN") {
            this.loanTypeFormTitle.innerHTML = "Loan amount";
            this.loanTypeTitle.innerHTML = "Loan amount";
            this.loanTypeFormStartDateTitle.innerHTML = "Loan start date";
            this.loanTypeStartDateTitle.innerHTML = "Loan start date";
            var _revolvedGroup = this.revolved.closest(".wpbbsa-calculator-form__group--none");
            _revolvedGroup.classList.add("wpbbsa-calculator-form__hidden");
            var termLoanInsuranceType = this.calculatorForm.querySelector("select[name=term-loan-insurance-type]");
            var revolvingLoanInsuranceType = this.calculatorForm.querySelector("select[name=revolving-loan-insurance-type]");
            var _termLoanInsuranceTypeGroup = termLoanInsuranceType.closest(".wpbbsa-calculator-form__group");
            var _revolvingLoanInsuranceTypeGroup = revolvingLoanInsuranceType.closest(".wpbbsa-calculator-form__group");
            revolvingLoanInsuranceType.removeAttribute("data-validation-required");
            _revolvingLoanInsuranceTypeGroup.classList.add("wpbbsa-calculator-form__hidden");
            _termLoanInsuranceTypeGroup.classList.remove("wpbbsa-calculator-form__hidden");
            termLoanInsuranceType.setAttribute("data-validation-required", "true");
            this.updateRevolved(false);
        }
        else if (loanType === "REVOLVING LOAN - NO LIMIT CHANGE") {
            this.loanTypeFormTitle.innerHTML = "Original Loan Limit";
            this.loanTypeTitle.innerHTML = "Original Loan Limit";
            this.loanTypeFormStartDateTitle.innerHTML = "Original Loan Date";
            this.loanTypeStartDateTitle.innerHTML = "Original Loan Date";
            var _revolvedGroup = this.revolved.closest(".wpbbsa-calculator-form__group--none");
            _revolvedGroup.classList.remove("wpbbsa-calculator-form__hidden");
            var termLoanInsuranceType = this.calculatorForm.querySelector("select[name=term-loan-insurance-type]");
            var revolvingLoanInsuranceType = this.calculatorForm.querySelector("select[name=revolving-loan-insurance-type]");
            var _termLoanInsuranceTypeGroup = termLoanInsuranceType.closest(".wpbbsa-calculator-form__group");
            var _revolvingLoanInsuranceTypeGroup = revolvingLoanInsuranceType.closest(".wpbbsa-calculator-form__group");
            termLoanInsuranceType.removeAttribute("data-validation-required");
            _termLoanInsuranceTypeGroup.classList.add("wpbbsa-calculator-form__hidden");
            _revolvingLoanInsuranceTypeGroup.classList.remove("wpbbsa-calculator-form__hidden");
            revolvingLoanInsuranceType.setAttribute("data-validation-required", "true");
        }
        else if (loanType === "REVOLVING LOAN - LIMIT CHANGE") {
            this.loanTypeFormTitle.innerHTML = "Recently Changed Limit";
            this.loanTypeTitle.innerHTML = "Recently Changed Limit";
            this.loanTypeFormStartDateTitle.innerHTML =
                "Last Limit Increase Date";
            this.loanTypeStartDateTitle.innerHTML = "Last Limit Increase Date";
            var _revolvedGroup = this.revolved.closest(".wpbbsa-calculator-form__group--none");
            _revolvedGroup.classList.remove("wpbbsa-calculator-form__hidden");
            var termLoanInsuranceType = this.calculatorForm.querySelector("select[name=term-loan-insurance-type]");
            var revolvingLoanInsuranceType = this.calculatorForm.querySelector("select[name=revolving-loan-insurance-type]");
            var _termLoanInsuranceTypeGroup = termLoanInsuranceType.closest(".wpbbsa-calculator-form__group");
            var _revolvingLoanInsuranceTypeGroup = revolvingLoanInsuranceType.closest(".wpbbsa-calculator-form__group");
            termLoanInsuranceType.removeAttribute("data-validation-required");
            _termLoanInsuranceTypeGroup.classList.add("wpbbsa-calculator-form__hidden");
            _revolvingLoanInsuranceTypeGroup.classList.remove("wpbbsa-calculator-form__hidden");
            revolvingLoanInsuranceType.setAttribute("data-validation-required", "true");
        }
    };
    CalculatorsPersonalloansAmortisation.prototype.updateMadeAnAdditionalPayment = function (madeAnAdditionalPayment) {
        if (this.additionalPaymentItems) {
            if (madeAnAdditionalPayment) {
                if (this.numberOfAdditionalPayments === 0) {
                    this.addAdditionalPayment();
                }
                var additionalPaymentItemsChildren = this.additionalPaymentItems.querySelectorAll(".wpbbsa-calculator-form__group");
                additionalPaymentItemsChildren.forEach(function (elem) {
                    elem.classList.remove("wpbbsa-calculator-form__hidden");
                });
                this.additionalPaymentItems.classList.remove("wpbbsa-calculator-form__hidden");
                this.addRemoveAdditionalPayments.classList.remove("wpbbsa-calculator-form__hidden");
            }
            else {
                var additionalPaymentItemsChildren = this.additionalPaymentItems.querySelectorAll(".wpbbsa-calculator-form__group");
                additionalPaymentItemsChildren.forEach(function (elem) {
                    elem.classList.add("wpbbsa-calculator-form__hidden");
                });
                this.additionalPaymentItems.classList.add("wpbbsa-calculator-form__hidden");
                this.addRemoveAdditionalPayments.classList.add("wpbbsa-calculator-form__hidden");
            }
        }
    };
    CalculatorsPersonalloansAmortisation.prototype.updateHaveMissedPayment = function (haveMissedPayment) {
        if (this.missedPaymentItems) {
            if (haveMissedPayment) {
                if (this.numberOfMissedPayments === 0) {
                    this.addMissedPayment();
                }
                var missedPaymentItemsChildren = this.missedPaymentItems.querySelectorAll(".wpbbsa-calculator-form__group");
                missedPaymentItemsChildren.forEach(function (elem) {
                    elem.classList.remove("wpbbsa-calculator-form__hidden");
                });
                this.missedPaymentItems.classList.remove("wpbbsa-calculator-form__hidden");
                this.addRemoveMissedPayments.classList.remove("wpbbsa-calculator-form__hidden");
            }
            else {
                var missedPaymentItemsChildren = this.missedPaymentItems.querySelectorAll(".wpbbsa-calculator-form__group");
                missedPaymentItemsChildren.forEach(function (elem) {
                    elem.classList.add("wpbbsa-calculator-form__hidden");
                });
                this.missedPaymentItems.classList.add("wpbbsa-calculator-form__hidden");
                this.addRemoveMissedPayments.classList.add("wpbbsa-calculator-form__hidden");
            }
        }
    };
    CalculatorsPersonalloansAmortisation.prototype.updateRevolved = function (revolved) {
        if (this.revolvedItems) {
            if (revolved) {
                if (this.numberOfRevolves === 0) {
                    this.addRevolved();
                }
                var revolvedItemsChildren = this.revolvedItems.querySelectorAll(".wpbbsa-calculator-form__group");
                revolvedItemsChildren.forEach(function (elem) {
                    elem.classList.remove("wpbbsa-calculator-form__hidden");
                });
                this.revolvedItems.classList.remove("wpbbsa-calculator-form__hidden");
                this.addRemoveRevolves.classList.remove("wpbbsa-calculator-form__hidden");
            }
            else {
                var revolvedItemsChildren = this.revolvedItems.querySelectorAll(".wpbbsa-calculator-form__group");
                revolvedItemsChildren.forEach(function (elem) {
                    elem.classList.add("wpbbsa-calculator-form__hidden");
                });
                this.revolvedItems.classList.add("wpbbsa-calculator-form__hidden");
                this.addRemoveRevolves.classList.add("wpbbsa-calculator-form__hidden");
            }
        }
    };
    CalculatorsPersonalloansAmortisation.prototype.addAdditionalPayment = function () {
        if (this.numberOfAdditionalPayments <= 20) {
            this.numberOfAdditionalPayments++;
            var addAdditionalPaymentDetailsDiv = document.createElement("div");
            addAdditionalPaymentDetailsDiv.classList.add("additionalPaymentItem-" + this.numberOfAdditionalPayments);
            var additionalPaymentDateGroup = document.createElement("div");
            additionalPaymentDateGroup.classList.add("form__group", "wpbbsa-calculator-form__group");
            var additionalPaymentDateLabel = document.createElement("label");
            additionalPaymentDateLabel.setAttribute("for", "date-of-additional-payment-" + this.numberOfAdditionalPayments);
            additionalPaymentDateLabel.classList.add("form__label", "wpbbsa-calculator-form__label");
            additionalPaymentDateLabel.textContent = "Date of Additional Payment " + this.numberOfAdditionalPayments;
            additionalPaymentDateGroup.appendChild(additionalPaymentDateLabel);
            var additionalPaymentDateInputRow = document.createElement("div");
            additionalPaymentDateInputRow.classList.add("row", "no-gutters");
            var additionalPaymentDateInputCol = document.createElement("div");
            additionalPaymentDateInputCol.classList.add("col", "col-12");
            var additionalPaymentDateInput = document.createElement("input");
            additionalPaymentDateInput.type = "text";
            additionalPaymentDateInput.name = "date-of-additional-payment-" + this.numberOfAdditionalPayments;
            additionalPaymentDateInput.value = "";
            additionalPaymentDateInput.classList.add("form__input", "form__input--required", "form__input--date", "js-date-picker-full", "form__datepicker", "dynamicElement");
            additionalPaymentDateInput.setAttribute("data-validation-required", "true");
            additionalPaymentDateInputCol.appendChild(additionalPaymentDateInput);
            additionalPaymentDateInputRow.appendChild(additionalPaymentDateInputCol);
            additionalPaymentDateGroup.appendChild(additionalPaymentDateInputRow);
            var additionalPaymentAmountGroup = document.createElement("div");
            additionalPaymentAmountGroup.classList.add("form__group", "wpbbsa-calculator-form__group");
            var additionalPaymentAmountLabel = document.createElement("label");
            additionalPaymentAmountLabel.setAttribute("for", "amount-of-additional-payment-" + this.numberOfAdditionalPayments);
            additionalPaymentAmountLabel.classList.add("form__label", "wpbbsa-calculator-form__label");
            additionalPaymentAmountLabel.textContent = "Additional Payment Amount " + this.numberOfAdditionalPayments;
            additionalPaymentAmountGroup.appendChild(additionalPaymentAmountLabel);
            var additionalPaymentAmountInputRow = document.createElement("div");
            additionalPaymentAmountInputRow.classList.add("row", "no-gutters");
            var additionalPaymentAmountInputCol = document.createElement("div");
            additionalPaymentAmountInputCol.classList.add("col", "col-12");
            var additionalPaymentAmountSpan = document.createElement("span");
            additionalPaymentAmountSpan.classList.add("title", "title--currency", "wpbbsa-calculator-form__title", "wpbbsa-calculator-form__title--currency");
            additionalPaymentAmountSpan.textContent = "R";
            var additionalPaymentAmountInput = document.createElement("input");
            additionalPaymentAmountInput.type = "number";
            additionalPaymentAmountInput.name = "amount-of-additional-payment-" + this.numberOfAdditionalPayments;
            additionalPaymentAmountInput.value = "";
            additionalPaymentAmountInput.classList.add("form-control", "form__input", "wpbbsa-calculator-form__input", "form__input--number", "wpbbsa-calculator-form__input--inline", "dynamicElement");
            additionalPaymentAmountInput.setAttribute("step", "1");
            additionalPaymentAmountInput.setAttribute("min", "1");
            additionalPaymentAmountInput.setAttribute("data-value", "");
            additionalPaymentAmountInput.setAttribute("data-validation-required", "true");
            additionalPaymentAmountInput.setAttribute("placeholder", "0");
            additionalPaymentAmountInputCol.appendChild(additionalPaymentAmountSpan);
            additionalPaymentAmountInputCol.appendChild(additionalPaymentAmountInput);
            additionalPaymentAmountInputRow.appendChild(additionalPaymentAmountInputCol);
            additionalPaymentAmountGroup.appendChild(additionalPaymentAmountInputRow);
            addAdditionalPaymentDetailsDiv.appendChild(additionalPaymentDateGroup);
            addAdditionalPaymentDetailsDiv.appendChild(additionalPaymentAmountGroup);
            this.additionalPaymentItems.appendChild(addAdditionalPaymentDetailsDiv);
            this.wpbbsaCalculatorService.initializeDatePickers();
        }
        this.updateAddRemoveAdditionalPayments();
    };
    CalculatorsPersonalloansAmortisation.prototype.removeAdditionalPayment = function () {
        if (this.numberOfAdditionalPayments >= 1) {
            var lastAdditionalPayment = this.calculatorForm.querySelector(".additionalPaymentItem-" + this.numberOfAdditionalPayments);
            lastAdditionalPayment.parentElement.removeChild(lastAdditionalPayment);
            this.numberOfAdditionalPayments--;
        }
        this.updateAddRemoveAdditionalPayments();
    };
    CalculatorsPersonalloansAmortisation.prototype.updateAddRemoveAdditionalPayments = function () {
        if (this.numberOfAdditionalPayments >= 20) {
            this.addAdditionalPaymentDiv.classList.add("wpbbsa-calculator-form__hidden");
        }
        else {
            this.addAdditionalPaymentDiv.classList.remove("wpbbsa-calculator-form__hidden");
        }
        if (this.numberOfAdditionalPayments <= 1) {
            this.removeAdditionalPaymentDiv.classList.add("wpbbsa-calculator-form__hidden");
        }
        else {
            this.removeAdditionalPaymentDiv.classList.remove("wpbbsa-calculator-form__hidden");
        }
    };
    CalculatorsPersonalloansAmortisation.prototype.addMissedPayment = function () {
        if (this.numberOfMissedPayments <= 20) {
            this.numberOfMissedPayments++;
            var addMissedPaymentDetailsDiv = document.createElement("div");
            addMissedPaymentDetailsDiv.classList.add("missedPaymentItem-" + this.numberOfMissedPayments);
            var missedPaymentDateGroup = document.createElement("div");
            missedPaymentDateGroup.classList.add("form__group", "wpbbsa-calculator-form__group");
            var missedPaymentDateLabel = document.createElement("label");
            missedPaymentDateLabel.setAttribute("for", "date-of-missed-payment-" + this.numberOfMissedPayments);
            missedPaymentDateLabel.classList.add("form__label", "wpbbsa-calculator-form__label");
            missedPaymentDateLabel.textContent = "Date of Missed Payment " + this.numberOfMissedPayments;
            missedPaymentDateGroup.appendChild(missedPaymentDateLabel);
            var missedPaymentDateInputRow = document.createElement("div");
            missedPaymentDateInputRow.classList.add("row", "no-gutters");
            var missedPaymentDateInputCol = document.createElement("div");
            missedPaymentDateInputCol.classList.add("col", "col-12");
            var missedPaymentDateInput = document.createElement("input");
            missedPaymentDateInput.type = "text";
            missedPaymentDateInput.name = "date-of-missed-payment-" + this.numberOfMissedPayments;
            missedPaymentDateInput.value = "";
            missedPaymentDateInput.classList.add("form__input", "form__input--required", "form__input--date", "js-date-picker-full", "form__datepicker", "dynamicElement");
            missedPaymentDateInput.setAttribute("data-validation-required", "true");
            missedPaymentDateInputCol.appendChild(missedPaymentDateInput);
            missedPaymentDateInputRow.appendChild(missedPaymentDateInputCol);
            missedPaymentDateGroup.appendChild(missedPaymentDateInputRow);
            addMissedPaymentDetailsDiv.appendChild(missedPaymentDateGroup);
            this.missedPaymentItems.appendChild(addMissedPaymentDetailsDiv);
            this.wpbbsaCalculatorService.initializeDatePickers();
        }
        this.updateAddRemoveMissedPayments();
    };
    CalculatorsPersonalloansAmortisation.prototype.removeMissedPayment = function () {
        if (this.numberOfMissedPayments >= 1) {
            var lastMissedPayment = this.calculatorForm.querySelector(".missedPaymentItem-" + this.numberOfMissedPayments);
            lastMissedPayment.parentElement.removeChild(lastMissedPayment);
            this.numberOfMissedPayments--;
        }
        this.updateAddRemoveMissedPayments();
    };
    CalculatorsPersonalloansAmortisation.prototype.updateAddRemoveMissedPayments = function () {
        if (this.numberOfMissedPayments >= 20) {
            this.addMissedPaymentDiv.classList.add("wpbbsa-calculator-form__hidden");
        }
        else {
            this.addMissedPaymentDiv.classList.remove("wpbbsa-calculator-form__hidden");
        }
        if (this.numberOfMissedPayments <= 1) {
            this.removeMissedPaymentDiv.classList.add("wpbbsa-calculator-form__hidden");
        }
        else {
            this.removeMissedPaymentDiv.classList.remove("wpbbsa-calculator-form__hidden");
        }
    };
    CalculatorsPersonalloansAmortisation.prototype.addRevolved = function () {
        if (this.numberOfRevolves <= 20) {
            this.numberOfRevolves++;
            var addRevolveDetailsDiv = document.createElement("div");
            addRevolveDetailsDiv.classList.add("revolvedItem-" + this.numberOfRevolves);
            var revolvedDateGroup = document.createElement("div");
            revolvedDateGroup.classList.add("form__group", "wpbbsa-calculator-form__group");
            var revolvedDateLabel = document.createElement("label");
            revolvedDateLabel.setAttribute("for", "date-of-revolved-" + this.numberOfRevolves);
            revolvedDateLabel.classList.add("form__label", "wpbbsa-calculator-form__label");
            revolvedDateLabel.textContent = "Date Revolved " + this.numberOfRevolves;
            revolvedDateGroup.appendChild(revolvedDateLabel);
            var revolvedDateInputRow = document.createElement("div");
            revolvedDateInputRow.classList.add("row", "no-gutters");
            var revolvedDateInputCol = document.createElement("div");
            revolvedDateInputCol.classList.add("col", "col-12");
            var revolvedDateInput = document.createElement("input");
            revolvedDateInput.type = "text";
            revolvedDateInput.name = "date-of-revolved-" + this.numberOfRevolves;
            revolvedDateInput.value = "";
            revolvedDateInput.classList.add("form__input", "form__input--required", "form__input--date", "js-date-picker-full", "form__datepicker", "dynamicElement");
            revolvedDateInput.setAttribute("data-validation-required", "true");
            revolvedDateInputCol.appendChild(revolvedDateInput);
            revolvedDateInputRow.appendChild(revolvedDateInputCol);
            revolvedDateGroup.appendChild(revolvedDateInputRow);
            var revolvedAmountGroup = document.createElement("div");
            revolvedAmountGroup.classList.add("form__group", "wpbbsa-calculator-form__group");
            var revolvedAmountLabel = document.createElement("label");
            revolvedAmountLabel.setAttribute("for", "amount-of-revolved-" + this.numberOfRevolves);
            revolvedAmountLabel.classList.add("form__label", "wpbbsa-calculator-form__label");
            revolvedAmountLabel.textContent = "Revolve Amount " + this.numberOfRevolves;
            revolvedAmountGroup.appendChild(revolvedAmountLabel);
            var revolvedAmountInputRow = document.createElement("div");
            revolvedAmountInputRow.classList.add("row", "no-gutters");
            var revolvedAmountInputCol = document.createElement("div");
            revolvedAmountInputCol.classList.add("col", "col-12");
            var revolvedAmountSpan = document.createElement("span");
            revolvedAmountSpan.classList.add("title", "title--currency", "wpbbsa-calculator-form__title", "wpbbsa-calculator-form__title--currency");
            revolvedAmountSpan.textContent = "R";
            var revolvedAmountInput = document.createElement("input");
            revolvedAmountInput.type = "number";
            revolvedAmountInput.name = "amount-of-revolved-" + this.numberOfRevolves;
            revolvedAmountInput.value = "";
            revolvedAmountInput.classList.add("form-control", "form__input", "wpbbsa-calculator-form__input", "form__input--number", "wpbbsa-calculator-form__input--inline", "dynamicElement");
            revolvedAmountInput.setAttribute("step", "1");
            revolvedAmountInput.setAttribute("min", "1");
            revolvedAmountInput.setAttribute("data-value", "");
            revolvedAmountInput.setAttribute("data-validation-required", "true");
            revolvedAmountInput.setAttribute("placeholder", "0");
            revolvedAmountInputCol.appendChild(revolvedAmountSpan);
            revolvedAmountInputCol.appendChild(revolvedAmountInput);
            revolvedAmountInputRow.appendChild(revolvedAmountInputCol);
            revolvedAmountGroup.appendChild(revolvedAmountInputRow);
            addRevolveDetailsDiv.appendChild(revolvedDateGroup);
            addRevolveDetailsDiv.appendChild(revolvedAmountGroup);
            this.revolvedItems.appendChild(addRevolveDetailsDiv);
            this.wpbbsaCalculatorService.initializeDatePickers();
        }
        this.updateAddRemoveRevolves();
    };
    CalculatorsPersonalloansAmortisation.prototype.removeRevolved = function () {
        if (this.numberOfRevolves >= 1) {
            var lastRevolve = this.calculatorForm.querySelector(".revolvedItem-" + this.numberOfRevolves);
            lastRevolve.parentElement.removeChild(lastRevolve);
            this.numberOfRevolves--;
        }
        this.updateAddRemoveRevolves();
    };
    CalculatorsPersonalloansAmortisation.prototype.updateAddRemoveRevolves = function () {
        if (this.numberOfRevolves >= 20) {
            this.addRevolvedDiv.classList.add("wpbbsa-calculator-form__hidden");
        }
        else {
            this.addRevolvedDiv.classList.remove("wpbbsa-calculator-form__hidden");
        }
        if (this.numberOfRevolves <= 1) {
            this.removeRevolvedDiv.classList.add("wpbbsa-calculator-form__hidden");
        }
        else {
            this.removeRevolvedDiv.classList.remove("wpbbsa-calculator-form__hidden");
        }
    };
    // -- CALCULATIONS --
    CalculatorsPersonalloansAmortisation.prototype.doCalcs = function (form) {
        // -- Amounts -- //
        var allAdditionalPayments = [];
        var allRevolves = [];
        // -- Dates -- //
        var allAdditionalPaymentDates = [];
        var allMissedPaymentDates = [];
        var allRevolvedDates = [];
        if (this.madeAdditionalPayments.checked) {
            for (var i = 1; i <= this.numberOfAdditionalPayments; i++) {
                var additionalPaymentAmount = form.querySelector("input[name=amount-of-additional-payment-" + i + "]");
                var additionalPaymentDate = form.querySelector("input[name=date-of-additional-payment-" + i + "]");
                allAdditionalPayments.push(Number(additionalPaymentAmount.value));
                allAdditionalPaymentDates.push(new Date(additionalPaymentDate.value));
            }
        }
        if (this.haveMissedPayments.checked) {
            for (var i = 1; i <= this.numberOfMissedPayments; i++) {
                var missedPaymentDate = form.querySelector("input[name=date-of-missed-payment-" + i + "]");
                allMissedPaymentDates.push(new Date(missedPaymentDate.value));
            }
        }
        if (this.revolved.checked) {
            for (var i = 1; i <= this.numberOfRevolves; i++) {
                var revolvedAmount = form.querySelector("input[name=amount-of-revolved-" + i + "]");
                var revolvedDate = form.querySelector("input[name=date-of-revolved-" + i + "]");
                allRevolves.push(Number(revolvedAmount.value));
                allRevolvedDates.push(new Date(revolvedDate.value));
            }
        }
        var loanType = this.loanType;
        if (loanType === "TERM LOAN") {
            var display_calculation_error = this.element.querySelectorAll("label[name=plua-calculate-calculateError]");
            var display_original_loan_amount = this.element.querySelectorAll("span.js-wpbbsa-calculator-original-loan-amount");
            var display_loan_start_date = this.element.querySelectorAll("span.js-wpbbsa-calculator-loan-date");
            var display_have_missed_payments_div = this.element.querySelectorAll(".js-wpbbsa-calculator-have-missed-payments--div");
            var display_have_missed_payments = this.element.querySelectorAll(".js-wpbbsa-calculator-have-missed-payments");
            var display_has_revolved_div = this.element.querySelectorAll(".js-wpbbsa-calculator-has-revolved--div");
            var display_has_revolved = this.element.querySelectorAll(".js-wpbbsa-calculator-has-revolved");
            var display_made_additional_payments_div = this.element.querySelectorAll(".js-wpbbsa-calculator-made-additional-payments--div");
            var display_made_additional_payments = this.element.querySelectorAll(".js-wpbbsa-calculator-made-additional-payments");
            var display_current_loan_repayment_amount = this.element.querySelectorAll("span.js-wpbbsa-calculator-current-loan-repayment-amount");
            var display_correct_loan_repayment_amount = this.element.querySelectorAll("span.js-wpbbsa-calculator-correct-loan-repayment-amount");
            var display_amount_of_months_paid_term = this.element.querySelectorAll("span.js-wpbbsa-calculator-months-paid");
            var display_loan_term_end_date = this.element.querySelectorAll("span.js-wpbbsa-calculator-loan-term-end-date");
            var display_variable_interest_rate = this.element.querySelectorAll("span.js-wpbbsa-calculator-variable-interest-rate");
            if (this.haveMissedPayments.checked) {
                for (var i = 0; i < display_have_missed_payments_div.length; i++) {
                    display_have_missed_payments_div[i].classList.remove("wpbbsa-calculator-form__hidden");
                }
            }
            else {
                for (var i = 0; i < display_have_missed_payments_div.length; i++) {
                    display_have_missed_payments_div[i].classList.add("wpbbsa-calculator-form__hidden");
                }
            }
            if (this.revolved.checked) {
                for (var i = 0; i < display_has_revolved_div.length; i++) {
                    display_has_revolved_div[i].classList.remove("wpbbsa-calculator-form__hidden");
                }
            }
            else {
                for (var i = 0; i < display_has_revolved_div.length; i++) {
                    display_has_revolved_div[i].classList.add("wpbbsa-calculator-form__hidden");
                }
            }
            if (this.madeAdditionalPayments.checked) {
                for (var i = 0; i < display_made_additional_payments_div.length; i++) {
                    display_made_additional_payments_div[i].classList.remove("wpbbsa-calculator-form__hidden");
                }
            }
            else {
                for (var i = 0; i < display_made_additional_payments_div.length; i++) {
                    display_made_additional_payments_div[i].classList.add("wpbbsa-calculator-form__hidden");
                }
            }
            var termLoanCalculations_1 = this.doTermLoanCalculations(form, allAdditionalPayments, allAdditionalPaymentDates, allMissedPaymentDates);
            // -- Calculation Error -- //
            [].slice.call(display_calculation_error).forEach(function (label) {
                label.innerHTML = termLoanCalculations_1.calculationErrorMessage;
            });
            // -- Original loan amount -- //
            [].slice.call(display_original_loan_amount).forEach(function (div) {
                div.innerHTML = termLoanCalculations_1.originalLoanAmount;
            });
            // -- Loan start date -- //
            [].slice.call(display_loan_start_date).forEach(function (div) {
                div.innerHTML = termLoanCalculations_1.startDateOfLoan;
            });
            // -- Current loan repayment amount -- //
            [].slice
                .call(display_current_loan_repayment_amount)
                .forEach(function (div) {
                div.innerHTML = termLoanCalculations_1.currentLoanRepayment;
            });
            // -- Correct loan repayment amount -- //
            [].slice
                .call(display_correct_loan_repayment_amount)
                .forEach(function (div) {
                div.innerHTML = termLoanCalculations_1.correctLoanRepayment;
            });
            // -- HAVE MISSED PAYMENTS -- //
            [].slice.call(display_have_missed_payments).forEach(function (div) {
                div.innerHTML = termLoanCalculations_1.haveMissedPaymentsChecked;
            });
            // -- HAS REVOLVED -- //
            [].slice.call(display_has_revolved).forEach(function (div) {
                div.innerHTML = termLoanCalculations_1.hasRevolvedChecked;
            });
            // -- MADE ADDITIONAL PAYMENTS -- //
            [].slice
                .call(display_made_additional_payments)
                .forEach(function (div) {
                div.innerHTML =
                    termLoanCalculations_1.madeAdditionalPaymentsChecked;
            });
            // -- Number of months paid -- //
            [].slice
                .call(display_amount_of_months_paid_term)
                .forEach(function (div) {
                div.innerHTML = termLoanCalculations_1.numberOfMonthsPaid;
            });
            // -- Loan Term end date -- //
            [].slice.call(display_loan_term_end_date).forEach(function (div) {
                div.innerHTML = termLoanCalculations_1.loanTermEndDate;
            });
            // -- Variable Interest Rate -- //
            [].slice
                .call(display_variable_interest_rate)
                .forEach(function (div) {
                div.innerHTML = termLoanCalculations_1.variableInterestRate;
            });
            // -- Amortisation Table -- //
            this.amortisationTableLabel.innerHTML =
                termLoanCalculations_1.amortisationTable;
        }
        else if (loanType === "REVOLVING LOAN - NO LIMIT CHANGE") {
            var display_calculation_error = this.element.querySelectorAll("label[name=plua-calculate-calculateError]");
            var display_original_loan_amount = this.element.querySelectorAll("span.js-wpbbsa-calculator-original-loan-amount");
            var display_loan_start_date = this.element.querySelectorAll("span.js-wpbbsa-calculator-loan-date");
            var display_have_missed_payments_div = this.element.querySelectorAll(".js-wpbbsa-calculator-have-missed-payments--div");
            var display_have_missed_payments = this.element.querySelectorAll(".js-wpbbsa-calculator-have-missed-payments");
            var display_has_revolved_div = this.element.querySelectorAll(".js-wpbbsa-calculator-has-revolved--div");
            var display_has_revolved = this.element.querySelectorAll(".js-wpbbsa-calculator-has-revolved");
            var display_made_additional_payments_div = this.element.querySelectorAll(".js-wpbbsa-calculator-made-additional-payments--div");
            var display_made_additional_payments = this.element.querySelectorAll(".js-wpbbsa-calculator-made-additional-payments");
            var display_current_loan_repayment_amount = this.element.querySelectorAll("span.js-wpbbsa-calculator-current-loan-repayment-amount");
            var display_correct_loan_repayment_amount = this.element.querySelectorAll("span.js-wpbbsa-calculator-correct-loan-repayment-amount");
            var display_amount_of_months_paid_term = this.element.querySelectorAll("span.js-wpbbsa-calculator-months-paid");
            var display_loan_term_end_date = this.element.querySelectorAll("span.js-wpbbsa-calculator-loan-term-end-date");
            var display_variable_interest_rate = this.element.querySelectorAll("span.js-wpbbsa-calculator-variable-interest-rate");
            if (this.haveMissedPayments.checked) {
                for (var i = 0; i < display_have_missed_payments_div.length; i++) {
                    display_have_missed_payments_div[i].classList.remove("wpbbsa-calculator-form__hidden");
                }
            }
            else {
                for (var i = 0; i < display_have_missed_payments_div.length; i++) {
                    display_have_missed_payments_div[i].classList.add("wpbbsa-calculator-form__hidden");
                }
            }
            if (this.revolved.checked) {
                for (var i = 0; i < display_has_revolved_div.length; i++) {
                    display_has_revolved_div[i].classList.remove("wpbbsa-calculator-form__hidden");
                }
            }
            else {
                for (var i = 0; i < display_has_revolved_div.length; i++) {
                    display_has_revolved_div[i].classList.add("wpbbsa-calculator-form__hidden");
                }
            }
            if (this.madeAdditionalPayments.checked) {
                for (var i = 0; i < display_made_additional_payments_div.length; i++) {
                    display_made_additional_payments_div[i].classList.remove("wpbbsa-calculator-form__hidden");
                }
            }
            else {
                for (var i = 0; i < display_made_additional_payments_div.length; i++) {
                    display_made_additional_payments_div[i].classList.add("wpbbsa-calculator-form__hidden");
                }
            }
            var calculations_1 = this.doRevolvingLoan_NoLimitChangeCalculations(form, allAdditionalPayments, allAdditionalPaymentDates, allMissedPaymentDates, allRevolves, allRevolvedDates);
            // -- Calculation Error -- //
            [].slice.call(display_calculation_error).forEach(function (label) {
                label.innerHTML = calculations_1.calculationErrorMessage;
            });
            // -- Original loan amount -- //
            [].slice.call(display_original_loan_amount).forEach(function (div) {
                div.innerHTML = calculations_1.originalLoanAmount;
            });
            // -- Loan start date -- //
            [].slice.call(display_loan_start_date).forEach(function (div) {
                div.innerHTML = calculations_1.startDateOfLoan;
            });
            // -- Current loan repayment amount -- //
            [].slice
                .call(display_current_loan_repayment_amount)
                .forEach(function (div) {
                div.innerHTML = calculations_1.currentLoanRepayment;
            });
            // -- Correct loan repayment amount -- //
            [].slice
                .call(display_correct_loan_repayment_amount)
                .forEach(function (div) {
                div.innerHTML = calculations_1.correctLoanRepayment;
            });
            // -- HAVE MISSED PAYMENTS -- //
            [].slice.call(display_have_missed_payments).forEach(function (div) {
                div.innerHTML = calculations_1.haveMissedPaymentsChecked;
            });
            // -- HAS REVOLVED -- //
            [].slice.call(display_has_revolved).forEach(function (div) {
                div.innerHTML = calculations_1.hasRevolvedChecked;
            });
            // -- MADE ADDITIONAL PAYMENTS -- //
            [].slice
                .call(display_made_additional_payments)
                .forEach(function (div) {
                div.innerHTML = calculations_1.madeAdditionalPaymentsChecked;
            });
            // -- Number of months paid -- //
            [].slice
                .call(display_amount_of_months_paid_term)
                .forEach(function (div) {
                div.innerHTML = calculations_1.numberOfMonthsPaid;
            });
            // -- Loan Term end date -- //
            [].slice.call(display_loan_term_end_date).forEach(function (div) {
                div.innerHTML = calculations_1.loanTermEndDate;
            });
            // -- Variable Interest Rate -- //
            [].slice
                .call(display_variable_interest_rate)
                .forEach(function (div) {
                div.innerHTML = calculations_1.variableInterestRate;
            });
            // -- Amortisation Table -- //
            this.amortisationTableLabel.innerHTML =
                calculations_1.amortisationTable;
        }
        else if (loanType === "REVOLVING LOAN - LIMIT CHANGE") {
            var display_calculation_error = this.element.querySelectorAll("label[name=plua-calculate-calculateError]");
            var display_original_loan_amount = this.element.querySelectorAll("span.js-wpbbsa-calculator-original-loan-amount");
            var display_loan_start_date = this.element.querySelectorAll("span.js-wpbbsa-calculator-loan-date");
            var display_have_missed_payments_div = this.element.querySelectorAll(".js-wpbbsa-calculator-have-missed-payments--div");
            var display_have_missed_payments = this.element.querySelectorAll(".js-wpbbsa-calculator-have-missed-payments");
            var display_has_revolved_div = this.element.querySelectorAll(".js-wpbbsa-calculator-has-revolved--div");
            var display_has_revolved = this.element.querySelectorAll(".js-wpbbsa-calculator-has-revolved");
            var display_made_additional_payments_div = this.element.querySelectorAll(".js-wpbbsa-calculator-made-additional-payments--div");
            var display_made_additional_payments = this.element.querySelectorAll(".js-wpbbsa-calculator-made-additional-payments");
            var display_current_loan_repayment_amount = this.element.querySelectorAll("span.js-wpbbsa-calculator-current-loan-repayment-amount");
            var display_correct_loan_repayment_amount = this.element.querySelectorAll("span.js-wpbbsa-calculator-correct-loan-repayment-amount");
            var display_amount_of_months_paid_term = this.element.querySelectorAll("span.js-wpbbsa-calculator-months-paid");
            var display_loan_term_end_date = this.element.querySelectorAll("span.js-wpbbsa-calculator-loan-term-end-date");
            var display_variable_interest_rate = this.element.querySelectorAll("span.js-wpbbsa-calculator-variable-interest-rate");
            if (this.haveMissedPayments.checked) {
                for (var i = 0; i < display_have_missed_payments_div.length; i++) {
                    display_have_missed_payments_div[i].classList.remove("wpbbsa-calculator-form__hidden");
                }
            }
            else {
                for (var i = 0; i < display_have_missed_payments_div.length; i++) {
                    display_have_missed_payments_div[i].classList.add("wpbbsa-calculator-form__hidden");
                }
            }
            if (this.revolved.checked) {
                for (var i = 0; i < display_has_revolved_div.length; i++) {
                    display_has_revolved_div[i].classList.remove("wpbbsa-calculator-form__hidden");
                }
            }
            else {
                for (var i = 0; i < display_has_revolved_div.length; i++) {
                    display_has_revolved_div[i].classList.add("wpbbsa-calculator-form__hidden");
                }
            }
            if (this.madeAdditionalPayments.checked) {
                for (var i = 0; i < display_made_additional_payments_div.length; i++) {
                    display_made_additional_payments_div[i].classList.remove("wpbbsa-calculator-form__hidden");
                }
            }
            else {
                for (var i = 0; i < display_made_additional_payments_div.length; i++) {
                    display_made_additional_payments_div[i].classList.add("wpbbsa-calculator-form__hidden");
                }
            }
            var calculations_2 = this.doRevolvingLoan_LimitChangeCalculations(form, allAdditionalPayments, allAdditionalPaymentDates, allMissedPaymentDates, allRevolves, allRevolvedDates);
            // -- Calculation Error -- //
            [].slice.call(display_calculation_error).forEach(function (label) {
                label.innerHTML = calculations_2.calculationErrorMessage;
            });
            // -- Original loan amount -- //
            [].slice.call(display_original_loan_amount).forEach(function (div) {
                div.innerHTML = calculations_2.originalLoanAmount;
            });
            // -- Loan start date -- //
            [].slice.call(display_loan_start_date).forEach(function (div) {
                div.innerHTML = calculations_2.startDateOfLoan;
            });
            // -- Current loan repayment amount -- //
            [].slice
                .call(display_current_loan_repayment_amount)
                .forEach(function (div) {
                div.innerHTML = calculations_2.currentLoanRepayment;
            });
            // -- Correct loan repayment amount -- //
            [].slice
                .call(display_correct_loan_repayment_amount)
                .forEach(function (div) {
                div.innerHTML = calculations_2.correctLoanRepayment;
            });
            // -- HAVE MISSED PAYMENTS -- //
            [].slice.call(display_have_missed_payments).forEach(function (div) {
                div.innerHTML = calculations_2.haveMissedPaymentsChecked;
            });
            // -- HAS REVOLVED -- //
            [].slice.call(display_has_revolved).forEach(function (div) {
                div.innerHTML = calculations_2.hasRevolvedChecked;
            });
            // -- MADE ADDITIONAL PAYMENTS -- //
            [].slice
                .call(display_made_additional_payments)
                .forEach(function (div) {
                div.innerHTML = calculations_2.madeAdditionalPaymentsChecked;
            });
            // -- Number of months paid -- //
            [].slice
                .call(display_amount_of_months_paid_term)
                .forEach(function (div) {
                div.innerHTML = calculations_2.numberOfMonthsPaid;
            });
            // -- Loan Term end date -- //
            [].slice.call(display_loan_term_end_date).forEach(function (div) {
                div.innerHTML = calculations_2.loanTermEndDate;
            });
            // -- Variable Interest Rate -- //
            [].slice
                .call(display_variable_interest_rate)
                .forEach(function (div) {
                div.innerHTML = calculations_2.variableInterestRate;
            });
            // -- Amortisation Table -- //
            this.amortisationTableLabel.innerHTML =
                calculations_2.amortisationTable;
        }
    };
    CalculatorsPersonalloansAmortisation.prototype.doTermLoanCalculations = function (form, allAdditionalPayments, allAdditionalPaymentDates, allMissedPaymentDates) {
        var loanAmount = form.querySelector("input[name=loan-amount]");
        var dateOfLoan = form.querySelector("input[name=date-of-loan]");
        var loanTerm = form.querySelector("input[name=term]");
        var initialInterest = form.querySelector("input[name=variable_interest_rate]");
        var insurance = form.querySelector("select[name=term-loan-insurance-type]");
        var currentMonthlyInstalment = form.querySelector("input[name=current-monthly-instalment]");
        var currentMonthlyInstalmentValue = Number(currentMonthlyInstalment.value);
        var monthlyServiceFee = 69.0;
        var initiationFee = Math.min(74.5 + 0.115 * loanAmount.value, 1207.5);
        var insuranceAmount = this.getInsuranceValue(insurance.value);
        var primeInterestRate = this.getPrimeInterestRateValue(new Date(dateOfLoan.value));
        var initailInterestRateMargin = initialInterest.value - primeInterestRate;
        var startDate = new Date(dateOfLoan.value);
        var startBalance = Number(loanAmount.value) + initiationFee;
        var arrAmortisation = new Array();
        var arrAmortisationCount = 0;
        var amortisationItemStart = new AmortisationItem();
        amortisationItemStart.date = startDate;
        amortisationItemStart.payment = 0.0;
        amortisationItemStart.extraPayment = 0.0;
        amortisationItemStart.missedPaymentAndRevolves = 0.0;
        amortisationItemStart.monthlyServiceFee = 0.0;
        amortisationItemStart.insuranceCost = 0.0;
        amortisationItemStart.interest = 0.0;
        amortisationItemStart.balance = startBalance;
        amortisationItemStart.interestRate =
            primeInterestRate + initailInterestRateMargin;
        arrAmortisation.push(amortisationItemStart);
        var increaseCountLimit = 0;
        var calculationError = false;
        var calculationErrorMessage = "";
        var newLoanCalc = 0;
        var newBalanceGreaterThanLoan = false;
        while (arrAmortisation[arrAmortisationCount].balance > 0) {
            var newDate = this.addMonth(startDate, arrAmortisation[arrAmortisationCount].date);
            var newExtraPayment = 0.0;
            if (this.madeAdditionalPayments.checked) {
                for (var i = 0; i < this.numberOfAdditionalPayments; i++) {
                    if (newDate.getMonth() ===
                        allAdditionalPaymentDates[i].getMonth() &&
                        newDate.getFullYear() ===
                            allAdditionalPaymentDates[i].getFullYear()) {
                        newExtraPayment += allAdditionalPayments[i];
                    }
                }
            }
            var newMissedPayment = 0.0;
            if (this.haveMissedPayments.checked) {
                for (var i = 0; i < this.numberOfMissedPayments; i++) {
                    if (newDate.getMonth() ===
                        allMissedPaymentDates[i].getMonth() &&
                        newDate.getFullYear() ===
                            allMissedPaymentDates[i].getFullYear()) {
                        newMissedPayment = currentMonthlyInstalmentValue;
                    }
                }
            }
            var newMonthlyServiceFee = arrAmortisation[arrAmortisationCount].balance > 0
                ? monthlyServiceFee
                : 0.0;
            var insuranceCostCalc = (insuranceAmount / 1000) *
                arrAmortisation[arrAmortisationCount].balance;
            var newInsuranceCost = Math.round((insuranceCostCalc + Number.EPSILON) * 100.0) /
                100.0;
            var interestCalc = (arrAmortisation[arrAmortisationCount].interestRate /
                100.0 /
                12) *
                arrAmortisation[arrAmortisationCount].balance;
            var newInterest = Math.round((interestCalc + Number.EPSILON) * 100.0) / 100.0;
            var paymentCalc = arrAmortisation[arrAmortisationCount].balance <
                currentMonthlyInstalmentValue
                ? arrAmortisation[arrAmortisationCount].balance +
                    newInterest +
                    newInsuranceCost +
                    newMonthlyServiceFee +
                    newMissedPayment -
                    newExtraPayment
                : currentMonthlyInstalmentValue;
            var newPayment = Math.round((paymentCalc + Number.EPSILON) * 100.0) / 100.0;
            var balanceCalc = arrAmortisation[arrAmortisationCount].balance +
                newMissedPayment +
                newMonthlyServiceFee +
                newInsuranceCost +
                newInterest -
                (newPayment + newExtraPayment);
            var newBalance = Math.round((balanceCalc + Number.EPSILON) * 100) / 100;
            var newPrimeInterestRate = this.getPrimeInterestRateValue(newDate);
            var newInterestRate = newPrimeInterestRate + initailInterestRateMargin;
            if (newBalance > arrAmortisation[arrAmortisationCount].balance) {
                increaseCountLimit++;
                if (newBalance > Number(loanAmount.value)) {
                    newLoanCalc = newBalance;
                    newBalanceGreaterThanLoan = true;
                }
                if (increaseCountLimit > 10) {
                    calculationError = true;
                    calculationErrorMessage =
                        "Based upon what you’ve entered, your current loan repayment calculated is lower than what you’re supposed to be paying. Paying less will result in your loan not being settled in the agreed term. Please contact us on 0860 000 000 to adjust your repayment.";
                    break;
                }
            }
            var newAmortisationItem = new AmortisationItem();
            newAmortisationItem.date = newDate;
            newAmortisationItem.payment = newPayment;
            newAmortisationItem.extraPayment = newExtraPayment;
            newAmortisationItem.missedPaymentAndRevolves = newMissedPayment;
            newAmortisationItem.monthlyServiceFee = newMonthlyServiceFee;
            newAmortisationItem.insuranceCost = newInsuranceCost;
            newAmortisationItem.interest = newInterest;
            newAmortisationItem.balance = newBalance;
            newAmortisationItem.interestRate = newInterestRate;
            arrAmortisation.push(newAmortisationItem);
            arrAmortisationCount++;
        }
        // -- CORRECT INSTALMENT CALCULATION -- //
        var num1 = newBalanceGreaterThanLoan
            ? newLoanCalc + initiationFee
            : Number(loanAmount.value) + initiationFee;
        var num2 = Number(initialInterest.value) / 100 / 12;
        var num3 = 1 + num2;
        var negTermsLoan = Number(loanTerm.value) * -1;
        var num4 = Math.pow(num3, negTermsLoan);
        var num5 = 1 - num4;
        var num6 = num2 / num5;
        var num7 = num1 * num6;
        var num8 = num7 * Number(loanTerm.value);
        var num9 = monthlyServiceFee * Number(loanTerm.value) + num8;
        var totalInsuranceCost = 0.0;
        for (var i = 0; i < arrAmortisation.length; i++) {
            totalInsuranceCost += arrAmortisation[i].insuranceCost;
        }
        var num10 = num9 + totalInsuranceCost;
        var correctLoanRepayment = Math.round((num10 / Number(loanTerm.value) + Number.EPSILON) * 100) / 100;
        // -- CORRECT INSTALMENT CALCULATION -- //
        // -- Original loan amount -- //
        var originalLoanAmount = loanAmount.value;
        // -- Start date of loan -- //
        var startDateOfLoan = "";
        var dtStartDateOfLoan;
        if (dateOfLoan.value !== "" && dateOfLoan.value != null) {
            dtStartDateOfLoan = new Date(dateOfLoan.value);
            if (dtStartDateOfLoan) {
                startDateOfLoan =
                    dtStartDateOfLoan.getDate().toString() +
                        " " +
                        this.monthNames[dtStartDateOfLoan.getMonth()].toString() +
                        " " +
                        dtStartDateOfLoan.getFullYear().toString();
            }
        }
        // -- Current Loan Repayment Amount -- //
        var currentLoanRepayment = currentMonthlyInstalment.value.toString();
        // -- Number of months paid -- //
        var numberOfMonthsPaid = "";
        if (dtStartDateOfLoan) {
            numberOfMonthsPaid = this.getNumberOfMonthsPaid(arrAmortisation);
        }
        // -- Loan term end date -- //
        var loanTermEndDate = "";
        if (calculationError === true) {
            loanTermEndDate = "No End Date";
        }
        else {
            if (arrAmortisation[arrAmortisation.length - 1].date) {
                loanTermEndDate =
                    this.monthNames[arrAmortisation[arrAmortisation.length - 1].date.getMonth()].toString() +
                        " " +
                        arrAmortisation[arrAmortisation.length - 1].date
                            .getFullYear()
                            .toString();
            }
        }
        // -- Variable interest rate -- //
        var variableInterestRate = initialInterest.value.toString();
        // -- Amortisation Table -- //
        var amortisationTable = "";
        if (calculationError === true) {
            amortisationTable =
                "<p>Based upon what you’ve entered, your current loan repayment calculated is lower than what you’re supposed to be paying. Paying less will result in your loan not being settled in the agreed term. Please contact us on 0860 000 000 to adjust your repayment.</p>";
        }
        else {
            amortisationTable = "<table class=\"calculators-personalloans-amortisation__table\">\n\t\t\t<thead>\n\t\t\t<tr class=\"calculators-personalloans-amortisation__table--tr\">\n\t\t\t<th scope=\"col\" class=\"calculators-personalloans-amortisation__table--th\">Month</th>\n\t\t\t<th scope=\"col\" class=\"calculators-personalloans-amortisation__table--th\">Payments</th>\n\t\t\t<th scope=\"col\" class=\"calculators-personalloans-amortisation__table--th\">Extra Payments</th>\n\t\t\t<th scope=\"col\" class=\"calculators-personalloans-amortisation__table--th\">Missed Payments & Revolves</th>\n\t\t\t<th scope=\"col\" class=\"calculators-personalloans-amortisation__table--th\">Monthly Service Fee</th>\n\t\t\t<th scope=\"col\" class=\"calculators-personalloans-amortisation__table--th\">Insurance Cost</th>\n\t\t\t<th scope=\"col\" class=\"calculators-personalloans-amortisation__table--th\">Interest</th>\n\t\t\t<th scope=\"col\" class=\"calculators-personalloans-amortisation__table--th\">Balance</th>\n\t\t\t</tr>\n\t\t\t</thead>\n\t\t\t<tbody>";
            for (var i = 0; i < arrAmortisation.length; i++) {
                amortisationTable +=
                    '<tr class="calculators-personalloans-amortisation__table--tr">';
                amortisationTable +=
                    '<td scope="row" data-label="Month" class="calculators-personalloans-amortisation__table--td">' +
                        this.monthNames[arrAmortisation[i].date.getMonth()]
                            .toString()
                            .substring(0, 3) +
                        " " +
                        arrAmortisation[i].date.getFullYear().toString() +
                        "</td>";
                amortisationTable +=
                    '<td data-label="Payments" class="calculators-personalloans-amortisation__table--td">' +
                        this.getAmortisationTableValue(arrAmortisation[i].payment) +
                        "</td>";
                amortisationTable +=
                    '<td data-label="Extra Payments" class="calculators-personalloans-amortisation__table--td">' +
                        this.getAmortisationTableValue(arrAmortisation[i].extraPayment) +
                        "</td>";
                amortisationTable +=
                    '<td data-label="Missed Payments" class="calculators-personalloans-amortisation__table--td">' +
                        this.getAmortisationTableValue(arrAmortisation[i].missedPaymentAndRevolves) +
                        "</td>";
                amortisationTable +=
                    '<td data-label="Monthly Service Fee" class="calculators-personalloans-amortisation__table--td">' +
                        this.getAmortisationTableValue(arrAmortisation[i].monthlyServiceFee) +
                        "</td>";
                amortisationTable +=
                    '<td data-label="Insurance Cost" class="calculators-personalloans-amortisation__table--td">' +
                        this.getAmortisationTableValue(arrAmortisation[i].insuranceCost) +
                        "</td>";
                amortisationTable +=
                    '<td data-label="Interest" class="calculators-personalloans-amortisation__table--td">' +
                        this.getAmortisationTableValue(arrAmortisation[i].interest) +
                        "</td>";
                amortisationTable +=
                    '<td data-label="Balance" class="calculators-personalloans-amortisation__table--td">' +
                        this.getAmortisationTableValue(arrAmortisation[i].balance) +
                        "</td>";
                amortisationTable += "</tr>";
            }
            amortisationTable += "</tbody>";
            amortisationTable += "</table>";
            amortisationTable +=
                '<div class="calculators-personalloans-amortisation__table-disclaimer"><h4>Disclaimer</h4><p>This online calculator provides an indication only. You use this online calculator at your own discretion. Standard Bank gives no warranty, express or implied, as to the accuracy, reliability and completeness of any information, formulae or calculation provided through the use of this calculator and does not accept any liability for loss or damage of whatsoever nature, which may be attributable to the reliance on and use of this calculator. We do not warrant the integrity and security of this calculator or that it is free of errors, corruption, viruses, interception or interference.</p></div>';
        }
        this.amortisationTableLabel.innerHTML = amortisationTable;
        return {
            originalLoanAmount: originalLoanAmount,
            startDateOfLoan: startDateOfLoan,
            haveMissedPaymentsChecked: this.haveMissedPayments.checked
                ? "Yes"
                : "No",
            hasRevolvedChecked: this.revolved.checked ? "Yes" : "No",
            madeAdditionalPaymentsChecked: this.madeAdditionalPayments.checked
                ? "Yes"
                : "No",
            currentLoanRepayment: currentLoanRepayment,
            correctLoanRepayment: correctLoanRepayment,
            numberOfMonthsPaid: numberOfMonthsPaid,
            loanTermEndDate: loanTermEndDate,
            variableInterestRate: variableInterestRate,
            amortisationTable: amortisationTable,
            calculationErrorMessage: calculationErrorMessage,
        };
    };
    CalculatorsPersonalloansAmortisation.prototype.doRevolvingLoan_LimitChangeCalculations = function (form, allAdditionalPayments, allAdditionalPaymentDates, allMissedPaymentDates, allRevolves, allRevolvedDates) {
        var loanAmount = form.querySelector("input[name=loan-amount]");
        var dateOfLoan = form.querySelector("input[name=date-of-loan]");
        var loanTerm = form.querySelector("input[name=term]");
        var initialInterest = form.querySelector("input[name=variable_interest_rate]");
        var insurance = form.querySelector("select[name=revolving-loan-insurance-type]");
        var currentMonthlyInstalment = form.querySelector("input[name=current-monthly-instalment]");
        var currentMonthlyInstalmentValue = Number(currentMonthlyInstalment.value);
        var monthlyServiceFee = 69.0;
        var initiationFee = 0.0;
        var insuranceAmount = this.getInsuranceValue(insurance.value);
        var primeInterestRate = this.getPrimeInterestRateValue(new Date(dateOfLoan.value));
        var initailInterestRateMargin = initialInterest.value - primeInterestRate;
        var startDate = new Date(dateOfLoan.value);
        var startBalance = Number(loanAmount.value) + initiationFee;
        var arrAmortisation = new Array();
        var arrAmortisationCount = 0;
        var amortisationItemStart = new AmortisationItem();
        amortisationItemStart.date = startDate;
        amortisationItemStart.payment = 0.0;
        amortisationItemStart.extraPayment = 0.0;
        amortisationItemStart.missedPaymentAndRevolves = 0.0;
        amortisationItemStart.monthlyServiceFee = 0.0;
        amortisationItemStart.insuranceCost = 0.0;
        amortisationItemStart.interest = 0.0;
        amortisationItemStart.balance = startBalance;
        amortisationItemStart.interestRate =
            primeInterestRate + initailInterestRateMargin;
        arrAmortisation.push(amortisationItemStart);
        var increaseCountLimit = 0;
        var calculationError = false;
        var calculationErrorMessage = "";
        var newLoanCalc = 0;
        var newBalanceGreaterThanLoan = false;
        while (arrAmortisation[arrAmortisationCount].balance > 0) {
            var newDate = this.addMonth(startDate, arrAmortisation[arrAmortisationCount].date);
            var newExtraPayment = 0.0;
            if (this.madeAdditionalPayments.checked) {
                for (var i = 0; i < this.numberOfAdditionalPayments; i++) {
                    if (newDate.getMonth() ===
                        allAdditionalPaymentDates[i].getMonth() &&
                        newDate.getFullYear() ===
                            allAdditionalPaymentDates[i].getFullYear()) {
                        newExtraPayment += allAdditionalPayments[i];
                    }
                }
            }
            var newMissedPayment = 0.0;
            if (this.haveMissedPayments.checked) {
                for (var i = 0; i < this.numberOfMissedPayments; i++) {
                    if (newDate.getMonth() ===
                        allMissedPaymentDates[i].getMonth() &&
                        newDate.getFullYear() ===
                            allMissedPaymentDates[i].getFullYear()) {
                        newMissedPayment = currentMonthlyInstalmentValue;
                    }
                }
            }
            var newRevolveAmount = 0.0;
            if (this.revolved.checked) {
                for (var i = 0; i < this.numberOfRevolves; i++) {
                    if (newDate.getMonth() === allRevolvedDates[i].getMonth() &&
                        newDate.getFullYear() ===
                            allRevolvedDates[i].getFullYear()) {
                        newRevolveAmount += allRevolves[i];
                    }
                }
            }
            var newMonthlyServiceFee = arrAmortisation[arrAmortisationCount].balance > 0
                ? monthlyServiceFee
                : 0.0;
            var insuranceCostCalc = (insuranceAmount / 1000) *
                arrAmortisation[arrAmortisationCount].balance;
            var newInsuranceCost = Math.round((insuranceCostCalc + Number.EPSILON) * 100.0) /
                100.0;
            var interestCalc = (arrAmortisation[arrAmortisationCount].interestRate /
                100.0 /
                12) *
                arrAmortisation[arrAmortisationCount].balance;
            var newInterest = Math.round((interestCalc + Number.EPSILON) * 100.0) / 100.0;
            var paymentCalc = arrAmortisation[arrAmortisationCount].balance <
                currentMonthlyInstalmentValue
                ? arrAmortisation[arrAmortisationCount].balance +
                    newInterest +
                    newInsuranceCost +
                    newMonthlyServiceFee +
                    newMissedPayment -
                    newExtraPayment
                : currentMonthlyInstalmentValue;
            var newPayment = Math.round((paymentCalc + Number.EPSILON) * 100.0) / 100.0;
            var balanceCalc = arrAmortisation[arrAmortisationCount].balance +
                newMissedPayment +
                newRevolveAmount +
                newMonthlyServiceFee +
                newInsuranceCost +
                newInterest -
                (newPayment + newExtraPayment);
            var newBalance = Math.round((balanceCalc + Number.EPSILON) * 100) / 100;
            var newPrimeInterestRate = this.getPrimeInterestRateValue(newDate);
            var newInterestRate = newPrimeInterestRate + initailInterestRateMargin;
            if (newBalance > arrAmortisation[arrAmortisationCount].balance) {
                increaseCountLimit++;
                if (newBalance > Number(loanAmount.value)) {
                    newLoanCalc = newBalance;
                    newBalanceGreaterThanLoan = true;
                }
                if (increaseCountLimit > 10) {
                    calculationError = true;
                    calculationErrorMessage =
                        "Based upon what you’ve entered, your current loan repayment calculated is lower than what you’re supposed to be paying. Paying less will result in your loan not being settled in the agreed term. Please contact us on 0860 000 000 to adjust your repayment.";
                    break;
                }
            }
            var newAmortisationItem = new AmortisationItem();
            newAmortisationItem.date = newDate;
            newAmortisationItem.payment = newPayment;
            newAmortisationItem.extraPayment = newExtraPayment;
            newAmortisationItem.missedPaymentAndRevolves =
                newMissedPayment + newRevolveAmount;
            newAmortisationItem.monthlyServiceFee = newMonthlyServiceFee;
            newAmortisationItem.insuranceCost = newInsuranceCost;
            newAmortisationItem.interest = newInterest;
            newAmortisationItem.balance = newBalance;
            newAmortisationItem.interestRate = newInterestRate;
            arrAmortisation.push(newAmortisationItem);
            arrAmortisationCount++;
        }
        // -- CORRECT INSTALMENT CALCULATION -- //
        var num1 = newBalanceGreaterThanLoan
            ? newLoanCalc + initiationFee
            : Number(loanAmount.value) + initiationFee;
        var num2 = Number(initialInterest.value) / 100 / 12;
        var num3 = 1 + num2;
        var negTermsLoan = Number(loanTerm.value) * -1;
        var num4 = Math.pow(num3, negTermsLoan);
        var num5 = 1 - num4;
        var num6 = num2 / num5;
        var num7 = num1 * num6;
        var num8 = num7 * Number(loanTerm.value);
        var num9 = monthlyServiceFee * Number(loanTerm.value) + num8;
        var totalInsuranceCost = 0.0;
        for (var i = 0; i < arrAmortisation.length; i++) {
            totalInsuranceCost += arrAmortisation[i].insuranceCost;
        }
        var num10 = num9 + totalInsuranceCost;
        var correctLoanRepayment = Math.round((num10 / Number(loanTerm.value) + Number.EPSILON) * 100) / 100;
        // -- CORRECT INSTALMENT CALCULATION -- //
        // -- Original loan amount
        var originalLoanAmount = loanAmount.value;
        // -- Start date of loan -- //
        var startDateOfLoan = "";
        var dtStartDateOfLoan;
        if (dateOfLoan.value !== "" && dateOfLoan.value != null) {
            dtStartDateOfLoan = new Date(dateOfLoan.value);
            if (dtStartDateOfLoan) {
                startDateOfLoan =
                    dtStartDateOfLoan.getDate().toString() +
                        " " +
                        this.monthNames[dtStartDateOfLoan.getMonth()].toString() +
                        " " +
                        dtStartDateOfLoan.getFullYear().toString();
            }
        }
        // -- Current Loan Repayment Amount -- //
        var currentLoanRepayment = currentMonthlyInstalment.value.toString();
        // -- Number of months paid == //
        var numberOfMonthsPaid = "";
        if (dtStartDateOfLoan) {
            numberOfMonthsPaid = this.getNumberOfMonthsPaid(arrAmortisation);
        }
        // -- Loan term end date -- //
        var loanTermEndDate = "";
        if (calculationError === true) {
            loanTermEndDate = "No End Date";
        }
        else {
            if (arrAmortisation[arrAmortisation.length - 1].date) {
                loanTermEndDate =
                    this.monthNames[arrAmortisation[arrAmortisation.length - 1].date.getMonth()].toString() +
                        " " +
                        arrAmortisation[arrAmortisation.length - 1].date
                            .getFullYear()
                            .toString();
            }
        }
        // -- Variable interest rate -- //
        var variableInterestRate = initialInterest.value.toString();
        // -- Amortisation Table -- //
        var amortisationTable = "";
        if (calculationError === true) {
            amortisationTable =
                "<p>Based upon what you’ve entered, your current loan repayment calculated is lower than what you’re supposed to be paying. Paying less will result in your loan not being settled in the agreed term. Please contact us on 0860 000 000 to adjust your repayment.</p>";
        }
        else {
            amortisationTable = "<table class=\"calculators-personalloans-amortisation__table\">\n\t\t\t<thead>\n\t\t\t<tr class=\"calculators-personalloans-amortisation__table--tr\">\n\t\t\t<th scope=\"col\" class=\"calculators-personalloans-amortisation__table--th\">Month</th>\n\t\t\t<th scope=\"col\" class=\"calculators-personalloans-amortisation__table--th\">Payments</th>\n\t\t\t<th scope=\"col\" class=\"calculators-personalloans-amortisation__table--th\">Extra Payments</th>\n\t\t\t<th scope=\"col\" class=\"calculators-personalloans-amortisation__table--th\">Missed Payments & Revolves</th>\n\t\t\t<th scope=\"col\" class=\"calculators-personalloans-amortisation__table--th\">Monthly Service Fee</th>\n\t\t\t<th scope=\"col\" class=\"calculators-personalloans-amortisation__table--th\">Insurance Cost</th>\n\t\t\t<th scope=\"col\" class=\"calculators-personalloans-amortisation__table--th\">Interest</th>\n\t\t\t<th scope=\"col\" class=\"calculators-personalloans-amortisation__table--th\">Balance</th>\n\t\t\t</tr>\n\t\t\t</thead>\n\t\t\t<tbody>";
            for (var i = 0; i < arrAmortisation.length; i++) {
                amortisationTable +=
                    '<tr class="calculators-personalloans-amortisation__table--tr">';
                amortisationTable +=
                    '<td scope="row" data-label="Month" class="calculators-personalloans-amortisation__table--td">' +
                        this.monthNames[arrAmortisation[i].date.getMonth()]
                            .toString()
                            .substring(0, 3) +
                        " " +
                        arrAmortisation[i].date.getFullYear().toString() +
                        "</td>";
                amortisationTable +=
                    '<td data-label="Payments" class="calculators-personalloans-amortisation__table--td">' +
                        this.getAmortisationTableValue(arrAmortisation[i].payment) +
                        "</td>";
                amortisationTable +=
                    '<td data-label="Extra Payments" class="calculators-personalloans-amortisation__table--td">' +
                        this.getAmortisationTableValue(arrAmortisation[i].extraPayment) +
                        "</td>";
                amortisationTable +=
                    '<td data-label="Missed Payments" class="calculators-personalloans-amortisation__table--td">' +
                        this.getAmortisationTableValue(arrAmortisation[i].missedPaymentAndRevolves) +
                        "</td>";
                amortisationTable +=
                    '<td data-label="Monthly Service Fee" class="calculators-personalloans-amortisation__table--td">' +
                        this.getAmortisationTableValue(arrAmortisation[i].monthlyServiceFee) +
                        "</td>";
                amortisationTable +=
                    '<td data-label="Insurance Cost" class="calculators-personalloans-amortisation__table--td">' +
                        this.getAmortisationTableValue(arrAmortisation[i].insuranceCost) +
                        "</td>";
                amortisationTable +=
                    '<td data-label="Interest" class="calculators-personalloans-amortisation__table--td">' +
                        this.getAmortisationTableValue(arrAmortisation[i].interest) +
                        "</td>";
                amortisationTable +=
                    '<td data-label="Balance" class="calculators-personalloans-amortisation__table--td">' +
                        this.getAmortisationTableValue(arrAmortisation[i].balance) +
                        "</td>";
                amortisationTable += "</tr>";
            }
            amortisationTable += "</tbody>";
            amortisationTable += "</table>";
            amortisationTable +=
                '<div class="calculators-personalloans-amortisation__table-disclaimer"><h4>Disclaimer</h4><p>This online calculator provides an indication only. You use this online calculator at your own discretion. Standard Bank gives no warranty, express or implied, as to the accuracy, reliability and completeness of any information, formulae or calculation provided through the use of this calculator and does not accept any liability for loss or damage of whatsoever nature, which may be attributable to the reliance on and use of this calculator. We do not warrant the integrity and security of this calculator or that it is free of errors, corruption, viruses, interception or interference.</p></div>';
        }
        this.amortisationTableLabel.innerHTML = amortisationTable;
        return {
            originalLoanAmount: originalLoanAmount,
            startDateOfLoan: startDateOfLoan,
            haveMissedPaymentsChecked: this.haveMissedPayments.checked
                ? "Yes"
                : "No",
            hasRevolvedChecked: this.revolved.checked ? "Yes" : "No",
            madeAdditionalPaymentsChecked: this.madeAdditionalPayments.checked
                ? "Yes"
                : "No",
            currentLoanRepayment: currentLoanRepayment,
            correctLoanRepayment: correctLoanRepayment,
            numberOfMonthsPaid: numberOfMonthsPaid,
            loanTermEndDate: loanTermEndDate,
            variableInterestRate: variableInterestRate,
            amortisationTable: amortisationTable,
            calculationErrorMessage: calculationErrorMessage,
        };
    };
    CalculatorsPersonalloansAmortisation.prototype.doRevolvingLoan_NoLimitChangeCalculations = function (form, allAdditionalPayments, allAdditionalPaymentDates, allMissedPaymentDates, allRevolves, allRevolvedDates) {
        var loanAmount = form.querySelector("input[name=loan-amount]");
        var dateOfLoan = form.querySelector("input[name=date-of-loan]");
        var loanTerm = form.querySelector("input[name=term]");
        var initialInterest = form.querySelector("input[name=variable_interest_rate]");
        var insurance = form.querySelector("select[name=revolving-loan-insurance-type]");
        var currentMonthlyInstalment = form.querySelector("input[name=current-monthly-instalment]");
        var currentMonthlyInstalmentValue = Number(currentMonthlyInstalment.value);
        var monthlyServiceFee = 69.0;
        var initiationFee = Math.min(74.5 + 0.115 * loanAmount.value, 1207.5);
        var insuranceAmount = this.getInsuranceValue(insurance.value);
        var primeInterestRate = this.getPrimeInterestRateValue(new Date(dateOfLoan.value));
        var initailInterestRateMargin = initialInterest.value - primeInterestRate;
        var startDate = new Date(dateOfLoan.value);
        var startBalance = Number(loanAmount.value) + initiationFee;
        var arrAmortisation = new Array();
        var arrAmortisationCount = 0;
        var amortisationItemStart = new AmortisationItem();
        amortisationItemStart.date = startDate;
        amortisationItemStart.payment = 0.0;
        amortisationItemStart.extraPayment = 0.0;
        amortisationItemStart.missedPaymentAndRevolves = 0.0;
        amortisationItemStart.monthlyServiceFee = 0.0;
        amortisationItemStart.insuranceCost = 0.0;
        amortisationItemStart.interest = 0.0;
        amortisationItemStart.balance = startBalance;
        amortisationItemStart.interestRate =
            primeInterestRate + initailInterestRateMargin;
        arrAmortisation.push(amortisationItemStart);
        var increaseCountLimit = 0;
        var calculationError = false;
        var calculationErrorMessage = "";
        var newLoanCalc = 0;
        var newBalanceGreaterThanLoan = false;
        while (arrAmortisation[arrAmortisationCount].balance > 0) {
            var newDate = this.addMonth(startDate, arrAmortisation[arrAmortisationCount].date);
            var newExtraPayment = 0.0;
            if (this.madeAdditionalPayments.checked) {
                for (var i = 0; i < this.numberOfAdditionalPayments; i++) {
                    if (newDate.getMonth() ===
                        allAdditionalPaymentDates[i].getMonth() &&
                        newDate.getFullYear() ===
                            allAdditionalPaymentDates[i].getFullYear()) {
                        newExtraPayment += allAdditionalPayments[i];
                    }
                }
            }
            var newMissedPayment = 0.0;
            if (this.haveMissedPayments.checked) {
                for (var i = 0; i < this.numberOfMissedPayments; i++) {
                    if (newDate.getMonth() ===
                        allMissedPaymentDates[i].getMonth() &&
                        newDate.getFullYear() ===
                            allMissedPaymentDates[i].getFullYear()) {
                        newMissedPayment = currentMonthlyInstalmentValue;
                    }
                }
            }
            var newRevolveAmount = 0.0;
            if (this.revolved.checked) {
                for (var i = 0; i < this.numberOfRevolves; i++) {
                    if (newDate.getMonth() === allRevolvedDates[i].getMonth() &&
                        newDate.getFullYear() ===
                            allRevolvedDates[i].getFullYear()) {
                        newRevolveAmount += allRevolves[i];
                    }
                }
            }
            var newMonthlyServiceFee = arrAmortisation[arrAmortisationCount].balance > 0
                ? monthlyServiceFee
                : 0.0;
            var insuranceCostCalc = (insuranceAmount / 1000) *
                arrAmortisation[arrAmortisationCount].balance;
            var newInsuranceCost = Math.round((insuranceCostCalc + Number.EPSILON) * 100.0) /
                100.0;
            var interestCalc = (arrAmortisation[arrAmortisationCount].interestRate /
                100.0 /
                12) *
                arrAmortisation[arrAmortisationCount].balance;
            var newInterest = Math.round((interestCalc + Number.EPSILON) * 100.0) / 100.0;
            var paymentCalc = arrAmortisation[arrAmortisationCount].balance <
                currentMonthlyInstalmentValue
                ? arrAmortisation[arrAmortisationCount].balance +
                    newInterest +
                    newInsuranceCost +
                    newMonthlyServiceFee +
                    newMissedPayment -
                    newExtraPayment
                : currentMonthlyInstalmentValue;
            var newPayment = Math.round((paymentCalc + Number.EPSILON) * 100.0) / 100.0;
            var balanceCalc = arrAmortisation[arrAmortisationCount].balance +
                newMissedPayment +
                newRevolveAmount +
                newMonthlyServiceFee +
                newInsuranceCost +
                newInterest -
                (newPayment + newExtraPayment);
            var newBalance = Math.round((balanceCalc + Number.EPSILON) * 100) / 100;
            var newPrimeInterestRate = this.getPrimeInterestRateValue(newDate);
            var newInterestRate = newPrimeInterestRate + initailInterestRateMargin;
            if (newBalance > arrAmortisation[arrAmortisationCount].balance) {
                increaseCountLimit++;
                if (newBalance > Number(loanAmount.value)) {
                    newLoanCalc = newBalance;
                    newBalanceGreaterThanLoan = true;
                }
                if (increaseCountLimit > 10) {
                    calculationError = true;
                    calculationErrorMessage =
                        "Based upon what you’ve entered, your current loan repayment calculated is lower than what you’re supposed to be paying. Paying less will result in your loan not being settled in the agreed term. Please contact us on 0860 000 000 to adjust your repayment.";
                    break;
                }
            }
            var newAmortisationItem = new AmortisationItem();
            newAmortisationItem.date = newDate;
            newAmortisationItem.payment = newPayment;
            newAmortisationItem.extraPayment = newExtraPayment;
            newAmortisationItem.missedPaymentAndRevolves =
                newMissedPayment + newRevolveAmount;
            newAmortisationItem.monthlyServiceFee = newMonthlyServiceFee;
            newAmortisationItem.insuranceCost = newInsuranceCost;
            newAmortisationItem.interest = newInterest;
            newAmortisationItem.balance = newBalance;
            newAmortisationItem.interestRate = newInterestRate;
            arrAmortisation.push(newAmortisationItem);
            arrAmortisationCount++;
        }
        // -- CORRECT INSTALMENT CALCULATION -- //
        var num1 = newBalanceGreaterThanLoan
            ? newLoanCalc + initiationFee
            : Number(loanAmount.value) + initiationFee;
        var num2 = Number(initialInterest.value) / 100 / 12;
        var num3 = 1 + num2;
        var negTermsLoan = Number(loanTerm.value) * -1;
        var num4 = Math.pow(num3, negTermsLoan);
        var num5 = 1 - num4;
        var num6 = num2 / num5;
        var num7 = num1 * num6;
        var num8 = num7 * Number(loanTerm.value);
        var num9 = monthlyServiceFee * Number(loanTerm.value) + num8;
        var totalInsuranceCost = 0.0;
        for (var i = 0; i < arrAmortisation.length; i++) {
            totalInsuranceCost += arrAmortisation[i].insuranceCost;
        }
        var num10 = num9 + totalInsuranceCost;
        var correctLoanRepayment = Math.round((num10 / Number(loanTerm.value) + Number.EPSILON) * 100) / 100;
        // -- CORRECT INSTALMENT CALCULATION -- //
        // -- Original loan amount -- //
        var originalLoanAmount = loanAmount.value;
        // -- Start date of loan -- //
        var startDateOfLoan = "";
        var dtStartDateOfLoan;
        if (dateOfLoan.value !== "" && dateOfLoan.value != null) {
            dtStartDateOfLoan = new Date(dateOfLoan.value);
            if (dtStartDateOfLoan) {
                startDateOfLoan =
                    dtStartDateOfLoan.getDate().toString() +
                        " " +
                        this.monthNames[dtStartDateOfLoan.getMonth()].toString() +
                        " " +
                        dtStartDateOfLoan.getFullYear().toString();
            }
        }
        // -- Current Loan Repayment Amount -- //
        var currentLoanRepayment = currentMonthlyInstalment.value.toString();
        // -- Number of months paid -- //
        var numberOfMonthsPaid = "";
        if (dtStartDateOfLoan) {
            numberOfMonthsPaid = this.getNumberOfMonthsPaid(arrAmortisation);
        }
        // -- Loan term end date -- //
        var loanTermEndDate = "";
        if (calculationError === true) {
            loanTermEndDate = "No End Date";
        }
        else {
            if (arrAmortisation[arrAmortisation.length - 1].date) {
                loanTermEndDate =
                    this.monthNames[arrAmortisation[arrAmortisation.length - 1].date.getMonth()].toString() +
                        " " +
                        arrAmortisation[arrAmortisation.length - 1].date
                            .getFullYear()
                            .toString();
            }
        }
        // -- Variable interest rate -- //
        var variableInterestRate = initialInterest.value.toString();
        // -- Amortisation Table -- //
        var amortisationTable = "";
        if (calculationError === true) {
            amortisationTable =
                "<p>Based upon what you’ve entered, your current loan repayment calculated is lower than what you’re supposed to be paying. Paying less will result in your loan not being settled in the agreed term. Please contact us on 0860 000 000 to adjust your repayment.</p>";
        }
        else {
            amortisationTable = "<table class=\"calculators-personalloans-amortisation__table\">\n\t\t\t<thead>\n\t\t\t<tr class=\"calculators-personalloans-amortisation__table--tr\">\n\t\t\t<th scope=\"col\" class=\"calculators-personalloans-amortisation__table--th\">Month</th>\n\t\t\t<th scope=\"col\" class=\"calculators-personalloans-amortisation__table--th\">Payments</th>\n\t\t\t<th scope=\"col\" class=\"calculators-personalloans-amortisation__table--th\">Extra Payments</th>\n\t\t\t<th scope=\"col\" class=\"calculators-personalloans-amortisation__table--th\">Missed Payments & Revolves</th>\n\t\t\t<th scope=\"col\" class=\"calculators-personalloans-amortisation__table--th\">Monthly Service Fee</th>\n\t\t\t<th scope=\"col\" class=\"calculators-personalloans-amortisation__table--th\">Insurance Cost</th>\n\t\t\t<th scope=\"col\" class=\"calculators-personalloans-amortisation__table--th\">Interest</th>\n\t\t\t<th scope=\"col\" class=\"calculators-personalloans-amortisation__table--th\">Balance</th>\n\t\t\t</tr>\n\t\t\t</thead>\n\t\t\t<tbody>";
            for (var i = 0; i < arrAmortisation.length; i++) {
                amortisationTable +=
                    '<tr class="calculators-personalloans-amortisation__table--tr">';
                amortisationTable +=
                    '<td scope="row" data-label="Month" class="calculators-personalloans-amortisation__table--td">' +
                        this.monthNames[arrAmortisation[i].date.getMonth()]
                            .toString()
                            .substring(0, 3) +
                        " " +
                        arrAmortisation[i].date.getFullYear().toString() +
                        "</td>";
                amortisationTable +=
                    '<td data-label="Payments" class="calculators-personalloans-amortisation__table--td">' +
                        this.getAmortisationTableValue(arrAmortisation[i].payment) +
                        "</td>";
                amortisationTable +=
                    '<td data-label="Extra Payments" class="calculators-personalloans-amortisation__table--td">' +
                        this.getAmortisationTableValue(arrAmortisation[i].extraPayment) +
                        "</td>";
                amortisationTable +=
                    '<td data-label="Missed Payments" class="calculators-personalloans-amortisation__table--td">' +
                        this.getAmortisationTableValue(arrAmortisation[i].missedPaymentAndRevolves) +
                        "</td>";
                amortisationTable +=
                    '<td data-label="Monthly Service Fee" class="calculators-personalloans-amortisation__table--td">' +
                        this.getAmortisationTableValue(arrAmortisation[i].monthlyServiceFee) +
                        "</td>";
                amortisationTable +=
                    '<td data-label="Insurance Cost" class="calculators-personalloans-amortisation__table--td">' +
                        this.getAmortisationTableValue(arrAmortisation[i].insuranceCost) +
                        "</td>";
                amortisationTable +=
                    '<td data-label="Interest" class="calculators-personalloans-amortisation__table--td">' +
                        this.getAmortisationTableValue(arrAmortisation[i].interest) +
                        "</td>";
                amortisationTable +=
                    '<td data-label="Balance" class="calculators-personalloans-amortisation__table--td">' +
                        this.getAmortisationTableValue(arrAmortisation[i].balance) +
                        "</td>";
                amortisationTable += "</tr>";
            }
            amortisationTable += "</tbody>";
            amortisationTable += "</table>";
            amortisationTable +=
                '<div class="calculators-personalloans-amortisation__table-disclaimer"><h4>Disclaimer</h4><p>This online calculator provides an indication only. You use this online calculator at your own discretion. Standard Bank gives no warranty, express or implied, as to the accuracy, reliability and completeness of any information, formulae or calculation provided through the use of this calculator and does not accept any liability for loss or damage of whatsoever nature, which may be attributable to the reliance on and use of this calculator. We do not warrant the integrity and security of this calculator or that it is free of errors, corruption, viruses, interception or interference.</p></div>';
        }
        this.amortisationTableLabel.innerHTML = amortisationTable;
        return {
            originalLoanAmount: originalLoanAmount,
            startDateOfLoan: startDateOfLoan,
            haveMissedPaymentsChecked: this.haveMissedPayments.checked
                ? "Yes"
                : "No",
            hasRevolvedChecked: this.revolved.checked ? "Yes" : "No",
            madeAdditionalPaymentsChecked: this.madeAdditionalPayments.checked
                ? "Yes"
                : "No",
            currentLoanRepayment: currentLoanRepayment,
            correctLoanRepayment: correctLoanRepayment,
            numberOfMonthsPaid: numberOfMonthsPaid,
            loanTermEndDate: loanTermEndDate,
            variableInterestRate: variableInterestRate,
            amortisationTable: amortisationTable,
            calculationErrorMessage: calculationErrorMessage,
        };
    };
    CalculatorsPersonalloansAmortisation.prototype.getAmortisationTableValue = function (value) {
        if (value === 0 || value === "0") {
            return "0";
        }
        else {
            return value.toFixed(2);
        }
    };
    // -- FUNCTIONS -- //
    CalculatorsPersonalloansAmortisation.prototype.addMonth = function (startPaymentDate, date) {
        var isLeapYear = false;
        var startPaymentDay = Number(startPaymentDate.getDate());
        var paymentmonth = Number(date.getMonth());
        var paymentYear = Number(date.getFullYear());
        if (paymentYear % 400 === 0 ||
            (paymentYear % 4 === 0 && paymentYear % 100 !== 0)) {
            isLeapYear = true;
        }
        if (startPaymentDay === 31) {
            if (paymentmonth === 2 ||
                paymentmonth === 4 ||
                paymentmonth === 7 ||
                paymentmonth === 9) {
                return new Date(paymentYear, paymentmonth + 1, 30);
            }
            else if (paymentmonth === 6) {
                return new Date(paymentYear, paymentmonth + 1, 31);
            }
            else if (paymentmonth === 11) {
                return new Date(paymentYear + 1, 0, 31);
            }
            else if (paymentmonth === 0) {
                if (isLeapYear) {
                    return new Date(paymentYear, 1, 29);
                }
                else {
                    return new Date(paymentYear, 1, 28);
                }
            }
            else {
                return new Date(paymentYear, paymentmonth + 1, 31);
            }
        }
        else if (startPaymentDay === 30) {
            if (paymentmonth === 0) {
                if (isLeapYear) {
                    return new Date(paymentYear, 1, 29);
                }
                else {
                    return new Date(paymentYear, 1, 28);
                }
            }
            else {
                return new Date(paymentYear, paymentmonth + 1, 30);
            }
        }
        else if (startPaymentDay === 29) {
            if (paymentmonth === 0) {
                if (isLeapYear) {
                    return new Date(paymentYear, 1, 29);
                }
                else {
                    return new Date(paymentYear, 1, 28);
                }
            }
            else {
                return new Date(paymentYear, paymentmonth + 1, 29);
            }
        }
        else {
            return new Date(paymentYear, paymentmonth + 1, startPaymentDay);
        }
    };
    CalculatorsPersonalloansAmortisation.prototype.getNumberOfMonthsPaid = function (arrAmortisation) {
        var numberOfMonthsPaid = 0;
        var todaysDate = new Date();
        for (var i = 0; i < arrAmortisation.length; i++) {
            if (new Date(arrAmortisation[i].date) <= todaysDate) {
                if (arrAmortisation[i].missedPaymentAndRevolves > 0.0 &&
                    arrAmortisation[i].extraPayment > 0.0) {
                    numberOfMonthsPaid += 0;
                }
                else if (arrAmortisation[i].missedPaymentAndRevolves > 0.0) {
                    numberOfMonthsPaid -= 1;
                }
                else if (arrAmortisation[i].payment > 0.0) {
                    numberOfMonthsPaid += 1;
                }
                else {
                    numberOfMonthsPaid += 0;
                }
            }
            else {
                break;
            }
        }
        if (numberOfMonthsPaid <= 0) {
            return "0 Months";
        }
        else if (numberOfMonthsPaid === 1) {
            return "1 Month";
        }
        else {
            return numberOfMonthsPaid.toString() + " Months";
        }
    };
    CalculatorsPersonalloansAmortisation.prototype.getInsuranceValue = function (insurance) {
        if (insurance === "DEBT PROTECTION PLAN") {
            return 4.5;
        }
        else if (insurance === "COMPREHENSIVE") {
            return 2.74;
        }
        else if (insurance === "SELECT") {
            return 2.23;
        }
        else if (insurance === "BASIC") {
            return 1.42;
        }
        else {
            return 0;
        }
    };
    CalculatorsPersonalloansAmortisation.prototype.getPrimeInterestRateValue = function (date) {
        var constInterestRate = 20.25;
        var constPrimeRate = 10.0;
        // -- MONTH VARIABLE BEGINS AT 0 -- //
        if (date >= new Date(2010, Month.MARCH, 1) &&
            date < new Date(2010, Month.SEPTEMBER, 1)) {
            return 10.0;
        }
        else if (date >= new Date(2010, Month.SEPTEMBER, 1) &&
            date < new Date(2010, Month.NOVEMBER, 1)) {
            return 9.5;
        }
        else if (date >= new Date(2010, Month.NOVEMBER, 1) &&
            date < new Date(2012, Month.JULY, 1)) {
            return 9.0;
        }
        else if (date >= new Date(2012, Month.JULY, 1) &&
            date < new Date(2014, Month.JANUARY, 1)) {
            return 8.5;
        }
        else if (date >= new Date(2014, Month.JANUARY, 1) &&
            date < new Date(2014, Month.JULY, 1)) {
            return 9.0;
        }
        else if (date >= new Date(2014, Month.JULY, 1) &&
            date < new Date(2015, Month.JULY, 1)) {
            return 9.25;
        }
        else if (date >= new Date(2015, Month.JULY, 1) &&
            date < new Date(2015, Month.NOVEMBER, 1)) {
            return 9.5;
        }
        else if (date >= new Date(2015, Month.NOVEMBER, 1) &&
            date < new Date(2016, Month.JANUARY, 1)) {
            return 9.75;
        }
        else if (date >= new Date(2016, Month.JANUARY, 1) &&
            date < new Date(2016, Month.MARCH, 1)) {
            return 10.25;
        }
        else if (date >= new Date(2016, Month.MARCH, 1) &&
            date < new Date(2017, Month.JULY, 1)) {
            return 10.5;
        }
        else if (date >= new Date(2017, Month.JULY, 1) &&
            date < new Date(2018, Month.APRIL, 1)) {
            return 10.25;
        }
        else if (date >= new Date(2018, Month.APRIL, 1) &&
            date < new Date(2018, Month.NOVEMBER, 1)) {
            return 10.0;
        }
        else if (date >= new Date(2018, Month.NOVEMBER, 1) &&
            date < new Date(2019, Month.JULY, 1)) {
            return 10.25;
        }
        else if (date >= new Date(2019, Month.JULY, 1) &&
            date < new Date(2020, Month.JANUARY, 1)) {
            return 10.0;
        }
        else if (date >= new Date(2020, Month.JANUARY, 1)) {
            return 9.75;
        }
        else {
            return constPrimeRate;
        }
    };
    // -- RESET VALUES - FORM -- //
    CalculatorsPersonalloansAmortisation.prototype.resetForm = function () {
        var _numberOfAdditionalPayments = this.numberOfAdditionalPayments;
        var _numberOfMissedPayments = this.numberOfMissedPayments;
        var _numberOfRevolves = this.numberOfRevolves;
        for (var i = 0; i < _numberOfAdditionalPayments; i++) {
            this.removeAdditionalPayment();
        }
        for (var i = 0; i < _numberOfMissedPayments; i++) {
            this.removeMissedPayment();
        }
        for (var i = 0; i < _numberOfRevolves; i++) {
            this.removeRevolved();
        }
        this.updateMadeAnAdditionalPayment(false);
        this.updateHaveMissedPayment(false);
        this.updateRevolved(false);
        this.loanType = "TERM LOAN";
        // reset form
        this.dataHtmlCollection.forEach(function (item, index) {
            if (item.innerHTML.indexOf("form-item__insurance--personal__policy-number-type-container-first") != -1) {
                item.classList.remove("hidden");
            }
            if (item.innerHTML.indexOf("form-item__insurance--personal__policy-number-type-container-second") != -1) {
                item.classList.add("hidden");
            }
        });
        this.updateFormLoanType(this.loanType);
    };
    // -- RESET VALUES - OUTPUTS -- //
    CalculatorsPersonalloansAmortisation.prototype.resetValues = function () {
        this.resetForm();
        var original_loan_amount = document.querySelectorAll("span.js-wpbbsa-calculator-original-loan-amount");
        var curent_loan_repayment_amount = document.querySelectorAll("span.js-wpbbsa-calculator-current-loan-repayment-amount");
        var correct_loan_repayment_amount = document.querySelectorAll("span.js-wpbbsa-calculator-correct-loan-repayment-amount");
        var original_loan_date = document.querySelectorAll("span.js-wpbbsa-calculator-loan-date");
        var have_missed_payments = document.querySelectorAll("span.js-wpbbsa-calculator-have-missed-payments");
        var has_revolved = document.querySelectorAll("span.js-wpbbsa-calculator-has-revolved");
        var made_additional_payments = document.querySelectorAll("span.js-wpbbsa-calculator-made-additional-payments");
        var months_paid = document.querySelectorAll("span.js-wpbbsa-calculator-months-paid");
        var loan_term_end_date = document.querySelectorAll("span.js-wpbbsa-calculator-loan-term-end-date");
        var variable_interest_rate = document.querySelectorAll("span.js-wpbbsa-calculator-variable-interest-rate");
        var display_have_missed_payments_div = document.querySelectorAll(".js-wpbbsa-calculator-have-missed-payments--div");
        var display_has_revolved_div = document.querySelectorAll(".js-wpbbsa-calculator-has-revolved--div");
        var display_made_additional_payments_div = document.querySelectorAll(".js-wpbbsa-calculator-made-additional-payments--div");
        [].slice.call(original_loan_amount).forEach(function (div) {
            div.innerHTML = "0";
        });
        [].slice.call(curent_loan_repayment_amount).forEach(function (div) {
            div.innerHTML = "0";
        });
        [].slice.call(correct_loan_repayment_amount).forEach(function (div) {
            div.innerHTML = "0";
        });
        [].slice.call(original_loan_date).forEach(function (div) {
            div.innerHTML = "0";
        });
        [].slice.call(have_missed_payments).forEach(function (div) {
            div.innerHTML = "0";
        });
        [].slice.call(has_revolved).forEach(function (div) {
            div.innerHTML = "0";
        });
        [].slice.call(made_additional_payments).forEach(function (div) {
            div.innerHTML = "0";
        });
        [].slice.call(months_paid).forEach(function (div) {
            div.innerHTML = "0";
        });
        [].slice.call(loan_term_end_date).forEach(function (div) {
            div.innerHTML = "0";
        });
        [].slice.call(variable_interest_rate).forEach(function (div) {
            div.innerHTML = "0";
        });
        [].slice.call(display_have_missed_payments_div).forEach(function (div) {
            div.classList.add("wpbbsa-calculator-form__hidden");
        });
        [].slice.call(display_has_revolved_div).forEach(function (div) {
            div.classList.add("wpbbsa-calculator-form__hidden");
        });
        [].slice
            .call(display_made_additional_payments_div)
            .forEach(function (div) {
            div.classList.add("wpbbsa-calculator-form__hidden");
        });
    };
    return CalculatorsPersonalloansAmortisation;
}(Base));
export { CalculatorsPersonalloansAmortisation };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/calculators-personalloans-amortisation/calculators-personalloans-amortisation.component.ts
// module id = 787
// module chunks = 0